// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:00:58.033Z
// Property: Cambria Luxury Apartment Homes (ID: 6767906449167590)
// Collections: 30 amenities, 9 floorplans (live), 17 photos, 74 POIs, 5 reviews, 5 virtual tours, 5 office hours, 15 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167590",
  "property_external_id": "1124090",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cambria-luxury-apartment-homes-kansas-city-mo/sskg245/",
  "property_google_business_url": "https://www.google.com/maps/place/Cambria+Luxury+Apartment+Homes/@39.0431937,-94.5908958,768m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0efb87e7ceb59:0xfbe7f692107282f4!8m2!3d39.0431937!4d-94.5908958!16s%2Fg%2F1hm33hp3r?entry=ttu&g_ep=EgoyMDI2MDgxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124090 p1099042",
  "property_status": null,
  "property_slug": "cambria-luxury-apartment-homes",
  "property_name": "Cambria Luxury Apartment Homes",
  "property_website_url": "https://www.cambriaapts.com/",
  "property_domain": "https://www.cambriaapts.com/",
  "property_address": "333 W 46th Terrace",
  "property_full_address": "333 W 46th Terrace, Kansas City, MO 64112",
  "property_address_1": "333 W 46th Terrace",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64112",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Plaza Area",
  "property_address_latitude": "39.0431911",
  "property_address_longitude": "-94.5909101",
  "property_email": "rentcafe.ca@pricekc.com",
  "property_phone": "(816) 320-5384",
  "property_call_tracking_phone": "816-320-5384",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Cambria Luxury Apartment Homes</strong> pairs warm Tuscan-style interiors with modern comforts in studio, one, and two-bedroom residences near The Plaza. Enjoy pet-friendly living, select Plaza views, and thoughtful conveniences—then apply today to see what sets Cambria apart.</p>",
  "property_long_description": "A warm community in the heart of a breathtaking historic area--this is Cambria Luxury Apartment Homes. Enjoy lavish amenities, Tuscan-style interiors, and urban conveniences under the roof of a studio, one, or two-bedroom residence. Then, glance at the city's crown jewel from your window, the Country Club Plaza. Apply today to see what sets our luxury apartments on The Plaza in Kansas City apart!We've designed every nook and cranny to enhance your lifestyle, whether inside or outside these apartments in Country Club Plaza. Every morning, the sun greets you on the balcony or patio. As you make your way through your home, stop by the gourmet kitchen and use the stainless-steel appliances. With hardwood floors, carpets, generous closets, dishwashers, and washer and dryer sets, modernity blends seamlessly with timeless touches. Select units also look over The Plaza, while all residences are pet friendly.A host of luxurious amenities await past your doorstep. Elevator access, off-street parking spots, guest suites, along with copy and fax services are just some of the highlights. Plus, emergency maintenance services make your life all the more carefree.Ready to leap into a joyful future? Apply now!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of Cambria Apartments building with a parking garage entrance.",
    "public_id": "01a0101d-5586-757c-8ceb-38ca48ba8909",
    "storage_key": "property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp",
    "width": 1800,
    "height": 1199
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "96",
  "property_year_built": "2012",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.70833333333334",
  "property_admin_fee": "200",
  "property_application_fee": "60",
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "The following breeds and mixed breeds including them are not permitted: Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid.\n\nExotic, feral, wild, or inherently dangerous animals are not permitted.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://cambriaapts.securecafeapplicant.com/onlineleasing/content3/access/cambria2/floorplans",
  "property_resident_portal_url": "https://cambriaapts.securecafe.com/residentservices/cambria2/userlogin.aspx",
  "property_apply_now_url": "https://cambriaapts.securecafeapplicant.com/onlineleasing/content3/access/cambria2/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc924-2182-758d-8f50-e15163e58e9f.webp",
  "property_primary_logo_media": {
    "alt_text": "Cambria Luxury Rentals logo",
    "public_id": "019fc924-2182-758d-8f50-e15163e58e9f",
    "storage_key": "property/6767906449167590/019fc924-2182-758d-8f50-e15163e58e9f.webp",
    "width": 938,
    "height": 600
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc924-dcf2-753f-8a67-15d5aecbc82a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc924-dcf2-753f-8a67-15d5aecbc82a",
    "storage_key": "property/6767906449167590/019fc924-dcf2-753f-8a67-15d5aecbc82a.webp",
    "width": 938,
    "height": 600
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc924-cf3e-7012-abcc-ed59f4354e55.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc924-cf3e-7012-abcc-ed59f4354e55",
    "storage_key": "property/6767906449167590/019fc924-cf3e-7012-abcc-ed59f4354e55.webp",
    "width": 938,
    "height": 600
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#006A8E",
  "property_secondary_color": "#AC3931",
  "property_font_color": "#1a1a1a",
  "property_color_4": "#050609",
  "property_color_3": "#C6893F",
  "property_color_5": "#441151",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "642 - 1241",
  "property_sqft_min": "642",
  "property_sqft_max": "1241",
  "property_price_range": "1241 - 8034",
  "property_price_min": "1241",
  "property_price_max": "8034",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/CambriaKC/",
  "property_instagram_url": "https://www.instagram.com/cambriakc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWet8frjvwIcR9IJyEJL25_s",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cambria Luxury Apartment Homes",
  "property_home_romance_title": "Embrace Your Dream Lifestyle at Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Cambria Luxury Apartment Homes pairs a Country Club Plaza address with the conveniences that make a day run smoothly. Gated entry, elevator access to every floor, and assigned garage parking handle the practical side. A luxury coffee bar and a guest suite give you room beyond your own front door. Inside, Tuscan-style interiors meet modern fixtures: all-electric kitchens with stainless steel appliances, central air and heating, in-unit washer and dryer sets, and spacious closets. High-speed internet access, cable availability, copy and fax services, on-call emergency maintenance, and flexible rent payment options round out the community.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio, one-, and two-bedroom layouts</strong> at Cambria Luxury Apartment Homes range from 642 to 1,241 square feet across nine distinct floor plans. Compare features, square footage, and availability, then use the interactive property map to choose the apartment home that fits your next move.</p>",
  "property_home_gallery_blurb": "<p><strong>See Cambria from every angle.</strong> Preview polished apartment interiors, inviting community amenities, and thoughtfully designed spaces throughout the property—then open the full gallery for a closer look at luxury living in Kansas City.</p>",
  "property_home_neighborhood_blurb": "<p>Cambria Luxury Apartment Homes sits at 333 W. 46th Terrace with a Walk Score of 88, bordering the Country Club Plaza and <a href=\"/neighborhood\">minutes from downtown Kansas City</a>. Shopping, dining, and nightlife begin just outside the community, with UMKC, Rockhurst University, Saint Luke's Hospital, Lockton, the Kemper Museum of Contemporary Art, and Loose Park all close at hand.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise at Cambria.</strong> Reviews highlight attentive service, quick maintenance, and well-kept spaces, with special shoutouts for Heather’s kindness, professionalism, and follow-through. The everyday details stand out, too: spacious layouts, in-home washer and dryer convenience, covered or assigned parking, balconies with beautiful views, and a quiet setting near Plaza Area shops and restaurants. Read the reviews to see why one resident simply called Cambria “perfect.”</p>",
  "property_neighborhood_blurb": "<p>Cambria Luxury Apartment Homes borders the Country Club Plaza and a historic stretch of Kansas City. The address puts these apartments near The Plaza, near UMKC, and minutes from downtown Kansas City, with a Walk Score of 88 to go with it.</p><p><br></p><p><strong>Getting Around Kansas City from The Plaza</strong></p><p><br></p><p>Getting around from these apartments near Country Club Plaza works by bus or by car, with public transportation immediately outside the community. Lockton, Rockhurst University, and UMKC are all close by, and Saint Luke's Hospital of Kansas City sits just north of the community. Downtown Kansas City is minutes away. For longer trips, the community has access to both the US 71 and US 169 corridors, whether you are heading north, south, or across the city.</p><p><br></p><p><strong>Shopping and Dining on the Country Club Plaza</strong></p><p><br></p><p>The Plaza is the reason most people start looking at apartments in this part of Kansas City. Shopping, dining, and entertainment run straight through it, so the weekend tends to take care of itself. Cooper's Hawk Winery &amp; Restaurant serves New American, Brio Italian Grille covers Italian, and Fogo de Chao brings Brazilian churrasco, none of which requires leaving the neighborhood. Boutiques and storefronts line The Plaza itself, and downtown is minutes away when you want a bigger night out.</p><p><br></p><p><strong>Parks, Museums and Recreation</strong></p><p><br></p><p>The Nelson-Atkins Museum of Art is close by for an afternoon that costs nothing. Loose Park offers open green space and public tennis courts. Between those two, plus The Plaza's own architecture and its seasonal lighting displays, there is enough within a few minutes of the front door to fill most weekends.</p><p><br></p><p><strong>Schools in the Area</strong></p><p><br></p><p>The schools nearest Cambria Luxury Apartment Homes are Longfellow Elementary School, Central Middle School, and Central High School. Contact the applicable school district directly to confirm current attendance boundaries, enrollment requirements, and any other school information.</p><p>Residents at Cambria Luxury Apartment Homes can enjoy convenient access to schools in Kansas City, including Pembroke Hill School. Pembroke Hill serves students from early childhood through grade 12 and provides college-preparatory education with academic, arts, and athletic opportunities nearby. For future residents seeking enrollment at Pembroke Hill School, Cambria Luxury Apartment Homes offers the ideal place to call home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Your time at Cambria Luxury Apartment Homes is split between the Country Club Plaza and the community itself, and both are worth staying in. Our luxury apartments on The Plaza in <a href=\"/neighborhood\">Kansas City</a> were designed around the amenities you actually use, from the gated garage to the coffee bar downstairs. Here is the full list.</p><p>Comfort doesn't have to come at the price of convenience, and our apartment amenities are proof. Parking is assigned, so you never circle the lot looking for an empty spot, and covered, partially covered, and uncovered spaces are available depending on what is open at the time.</p><p>Gated access adds a layer of privacy, and the elevator keeps the trip between the garage and your door short. A luxury coffee bar sits downstairs, a guest suite gives visitors somewhere to stay, and copy and fax services spare you a trip into town. High-speed internet, cable connections, and on-call emergency maintenance round out the community, and flexible rent payment options are available through Flex.</p><p>Every <a href=\"/floor-plans\">apartment home</a> is built around the same core features. The all-electric kitchen comes fitted with stainless steel appliances, a dishwasher, microwave, refrigerator, and breakfast bar. Central air and heating hold your temperature year-round, and an in-unit washer and dryer means laundry never leaves the apartment.</p><p>Spacious closets, mini blinds, and cable-ready wiring come standard, with tile and carpet flooring throughout, and a private balcony or patio waits outside for the stretch while the laundry runs. Select homes add hardwood floors, a kitchen pantry, or a view of The Plaza, so ask which of those are available when you browse our floor plans.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Cambria home?</strong> Start your application online and move closer to a studio, one, or two-bedroom residence with Tuscan-style interiors, modern finishes, and pet-friendly comfort in the heart of Country Club Plaza. Apply today and see what sets Cambria Luxury Apartment Homes apart.</p>",
  "property_contactus_blurb": "<p>Have questions about <a href=\"/floor-plans\">apartment</a> availability, floor plans, <a href=\"/amenities\">amenities</a>, <a href=\"/schedule-a-tour\">tours</a>, or the <a href=\"https://cambriaapts.securecafeapplicant.com/onlineleasing/content3/access/cambria2/login\">application</a> process? Contact Cambria Luxury Apartment Homes for more information about our luxury apartments in Kansas City's Country Club Plaza. Use the contact form to send the leasing team a message, call the community, or get directions to Cambria Luxury Apartment Homes.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about Cambria Luxury Apartment Homes?</strong> Start here for quick answers about the community, leasing, and everyday living in our <a href=\"/floor-plans\">studio, one, and two-bedroom apartments</a> on The Plaza. If you need more details, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Find a layout that fits what you are looking for at Cambria Luxury Apartment Homes. Explore studio, one-, and two-bedroom apartment floor plans in a range of square footage, features, and availability, then <a href=\"/contact-us\">contact us</a> to set up an in-person tour, or check out our <a href=\"/virtual-tours\">virtual tours</a>. Homes run from 642 to 1,241 square feet across nine distinct plans.</p>",
  "property_gallery_blurb": "<p>Explore the Cambria Luxury Apartment Homes gallery and get a closer look at <a href=\"/virtual-tours\">apartment interiors</a>, community <a href=\"/amenities\">amenities</a>, and spaces throughout the property.</p><p>Like what you see? Browse available <a href=\"/floor-plans\">floor plans</a> or schedule a <a href=\"/schedule-a-tour\">tour</a> to experience Cambria Luxury Apartment Homes in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Cambria from every angle.</strong> Use the interactive map to browse available studio, one, and two-bedroom apartments, then see how this warm community places Tuscan-style interiors, urban conveniences, and views of the Country Club Plaza within a breathtaking historic area.</p>",
  "property_pets_blurb": "<p>Cambria Luxury Apartment Homes welcomes dogs and cats. Our Country Club Plaza location puts sidewalks, green space, and Loose Park close to the front door, so daily outings fit easily into the routine. Every pet-owning resident is also enrolled in the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>, which provides a card offering special offers and discounts at local pet-related businesses. Membership is included in your pet fee.</p><p><br></p><p>Assistance animals, including service animals and support animals, are not pets and are not subject to pet fees, pet rent, breed restrictions, or pet limits. Requests for a reasonable accommodation are reviewed in accordance with applicable fair housing law. Contact the leasing office to begin that process. Pet policies, fees, and restrictions are subject to change, so confirm current terms with the leasing team before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Cambria experience.</strong> If you love the warm community, Tuscan-style interiors, modern finishes, and views toward The Plaza, invite a friend to discover it too. Send a referral and help them find their next studio, one-, or two-bedroom home in the heart of this historic Kansas City setting.</p>",
  "property_residentaccess_blurb": "<p>The resident portal is where residents of Cambria Luxury Apartment Homes handle the practical side of living here. Log in to pay rent, submit and track maintenance requests, review lease documents, and update your contact information.  </p><p><strong> </strong></p><p>Pay rent through your resident online account using a bank account or a credit card. Cambria Luxury Apartment Homes has also partnered with Flex, which gives residents the option of splitting rent into smaller payments across the month. Contact the leasing office for details on enrolling.</p><p><strong> </strong></p><p>Submit non-urgent maintenance requests online through your resident account or by calling the leasing office. For a maintenance emergency, call the office directly. After hours, follow the prompts to reach the answering service.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Cambria.</strong> In reviews, one theme comes through clearly: attentive service makes daily living feel easier. Residents consistently call out Heather’s professionalism, kindness, and follow-through—from leasing questions to move-in coordination—along with maintenance requests handled quickly and spaces that are well kept.</p><p>You’ll also hear praise for the details that shape the experience: spacious layouts, in-home washer and dryer convenience, covered or assigned parking, balconies with beautiful views, and a quiet atmosphere near Plaza Area shops and restaurants. One resident summed it up simply: “Cambria is perfect.” Read the reviews below to get a firsthand look at life at Cambria Luxury Apartment Homes.</p>",
  "property_created_at": "1785785963059",
  "property_scheduletour_blurb": "<p>See Cambria Luxury Apartment Homes for yourself. Pick a date and time using the scheduler, or call the leasing office to arrange a visit. A tour covers an available <a href=\"/floor-plans\">apartment home</a> along with the community <a href=\"/amenities\">amenities</a>, including the luxury coffee bar, guest suite, elevator access, and gated garage parking, so plan for enough time to see both.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Cambria Luxury Apartment Homes’ leasing team will be in touch soon. In the meantime, picture Tuscan-style interiors, modern finishes, pet-friendly studio, one, and two-bedroom residences, and the warm ease of apartment living on The Plaza.</p>",
  "property_virtualtours_blurb": "<p>Step inside Cambria Luxury Apartment Homes without leaving your desk. The virtual tour lets you move through an apartment home and the shared spaces at your own pace, on your own schedule, from any device. It is the closest thing to standing in the room before you ever visit the Country Club Plaza.</p><p><br></p><p>Ready to see it in person? Schedule a visit to Cambria Luxury Apartment Homes, browse the photo gallery for more detail, or use the interactive property map to find exactly where each available home sits.</p>",
  "property_copyright": "2026 All Rights Reserved. Cambria Luxury Apartment Homes",
  "property_seo_title_home": "Luxury Apartments on the Country Club Plaza | KC",
  "property_seo_description_home": "Studio, 1 and 2 bedroom luxury apartments with gated access, elevator and in-unit laundry at Cambria Luxury Apartment Homes. View availability today.",
  "property_seo_title_floorplans": "Studio, 1 & 2 Bed Apartments, Country Club Plaza",
  "property_seo_description_floorplans": "Nine layouts from 642 to 1,241 square feet, each with an in-unit washer and dryer and stainless steel kitchen. See what is available at Cambria today.",
  "property_seo_title_amenities": "Apartment Amenities & Features | Cambria KC",
  "property_seo_description_amenities": "Gated access, garage parking, elevator, guest suite, luxury coffee bar and in-unit laundry. See every community and apartment feature at Cambria.",
  "property_seo_title_gallery": "Apartment Photos & Interiors | Cambria KC",
  "property_seo_description_gallery": "Browse photos of apartment interiors, community spaces and the building at Cambria Luxury Apartment Homes on Kansas City's Country Club Plaza.",
  "property_seo_title_virtualtours": "Take a Virtual Tour | Cambria Apartments KC",
  "property_seo_description_virtualtours": "Walk through Cambria Luxury Apartment Homes from anywhere. Explore our Country Club Plaza apartments online, then book an in-person visit today.",
  "property_seo_title_interactivemap": "Interactive Map | Cambria Luxury Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Cambria Luxury Apartment Homes in Kansas City! Explore floor plans, amenities, and pricing with our interactive map.",
  "property_seo_title_neighborhood": "Apartments Near The Plaza & UMKC | Cambria KC",
  "property_seo_description_neighborhood": "Shopping, dining and nightlife begin outside the door, with UMKC, Rockhurst, Saint Luke's and Lockton close by. Explore the Cambria neighborhood map.",
  "property_seo_title_contact": "Contact Our Kansas City Leasing Office | Cambria",
  "property_seo_description_contact": "Get in touch with the Cambria Luxury Apartment Homes leasing team about availability, floor plans, tours and applications on the Country Club Plaza.",
  "property_seo_title_faqs": "Apartment Leasing FAQs | Cambria, Kansas City",
  "property_seo_description_faqs": "Answers about applications, lease terms, deposits, rent payment, pets, parking and maintenance at Cambria Luxury Apartment Homes in Kansas City, MO.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Experience the Cambria Lifestyle in Kansas City! Check out glowing resident reviews and see why our luxury apartments are the perfect place to call home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Live luxuriously at Cambria Luxury Apartment Homes in Kansas City. Choose from stylish one and two-bedroom layouts with top-notch amenities. Apply online!",
  "property_seo_title_residentaccess": "Resident Portal & Online Rent Payment | Cambria",
  "property_seo_description_residentaccess": "Pay rent, submit maintenance requests, review lease documents and manage your account online. Log in to the Cambria Luxury Apartment Homes portal.",
  "property_seo_title_referafriend": "Refer A Friend | Cambria Luxury Apartment Homes",
  "property_seo_description_referafriend": "Invite your friends to experience the luxury of Cambria Apartment Homes in Kansas City! Great friends make great neighbors—share the joy today!",
  "property_seo_title_scheduletour": "Schedule an Apartment Tour in Kansas City | Cambria",
  "property_seo_description_scheduletour": "Book an in-person visit to Cambria Luxury Apartment Homes, or tour from anywhere with the virtual tour and interactive property map. Pick a time today.",
  "property_seo_title_privacy": "Privacy Policy | Cambria Luxury Apartment Homes",
  "property_seo_description_privacy": "At Cambria Luxury Apartment Homes in Kansas City, your privacy is our priority. View our privacy policy to learn more.",
  "property_seo_title_accessibility": "Website Accessibility | Cambria Luxury Apartment Homes",
  "property_seo_description_accessibility": "Discover seamless living at Cambria Luxury Apartments in Kansas City, where we prioritize digital accessibility for your comfort.",
  "property_seo_title_sitemap": "Sitemap | Cambria Luxury Apartment Homes",
  "property_seo_description_sitemap": "Unravel the details of Cambria Luxury Apartment Homes in Kansas City, MO. Check out our sitemap for easy navigation to your dream lifestyle!",
  "property_seo_title_thankyou": "Thank You | Cambria Luxury Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to luxury living at Cambria in Kansas City starts here. Expect a prompt response from our team soon!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Kansas City | Cambria",
  "property_seo_description_pets": "Dogs and cats are welcome at Cambria Luxury Apartment Homes, with two pets per home. Review pet rent, fees and breed restrictions before you apply.",
  "property_updated_at": "1793742952437",
  "amenities": [
    {
      "id": "ec_0f2a1a69a7e27fc1a8ed45f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091619",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1f0-7658-a02e-ac24b19c96d8.webp",
      "amenity_image_media": {
        "alt_text": "Hallway with elevators and exit signs.",
        "public_id": "01a0101c-d1f0-7658-a02e-ac24b19c96d8",
        "storage_key": "property/6767906449167590/01a0101c-d1f0-7658-a02e-ac24b19c96d8.webp",
        "width": 2000,
        "height": 1333
      },
      "amenity_image_alt_text": "Elevator Lobby at Cambria Luxury Apartment Homes, Kansas City, 64112",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ef3623e171a8fd9f3b38f34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091616",
      "title": "Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d49c-713a-978c-d207a2bd113a.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of a multifamily building with a covered parking garage below.",
        "public_id": "01a0101c-d49c-713a-978c-d207a2bd113a",
        "storage_key": "property/6767906449167590/01a0101c-d49c-713a-978c-d207a2bd113a.webp",
        "width": 1489,
        "height": 992
      },
      "amenity_image_alt_text": "Building at Cambria Apartments , Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efefef53e983f4b71eacc165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091613",
      "title": "Assigned Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72cbb1dd7e84707ade4a66ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091621",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-dba3-773d-bfa4-7c86b0ad8893.webp",
      "amenity_image_media": {
        "alt_text": "Exterior building entrance with brick facade and arched entryway with ornate metal gates.",
        "public_id": "01a0101c-dba3-773d-bfa4-7c86b0ad8893",
        "storage_key": "property/6767906449167590/01a0101c-dba3-773d-bfa4-7c86b0ad8893.webp",
        "width": 1510,
        "height": 1006
      },
      "amenity_image_alt_text": "Building entrance1 at Cambria Apartments , Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb43e9eacc399f14ff180251",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091622",
      "title": "Guest Suite",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c6d515562fbe7cc598f5fd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091612",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_463a840c95f892f3252199a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "120558538",
      "title": "Access to Plaza Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1bd-769d-b4ca-1668ce7b9f74.webp",
      "amenity_image_media": {
        "alt_text": "View of a street with shops and historic buildings, including a tower with a dome.",
        "public_id": "01a0101c-d1bd-769d-b4ca-1668ce7b9f74",
        "storage_key": "property/6767906449167590/01a0101c-d1bd-769d-b4ca-1668ce7b9f74.webp",
        "width": 2000,
        "height": 1333
      },
      "amenity_image_alt_text": "Rooftop View at Cambria Luxury Apartment Homes, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09c8a9ecda3e26b0454ddd0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091623",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1746ed1a712d3fabd4bd94c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091614",
      "title": "Cable Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d978d0c90bed6ae6a142e41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091620",
      "title": "On-Call Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eb7d7646969f700a38b1c64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091615",
      "title": "Copy & Fax Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54adbf5f24b281ae39f530a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "122755349",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53029fcc4e42f3e6461823a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "125497800",
      "title": "Luxury Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_974b0319de4021d993847973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091600",
      "title": "Hardwood Floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e3b5-71cb-a21b-34f349424cbf.webp",
      "amenity_image_media": {
        "alt_text": "Studio apartment with king bed, open kitchen, and closet.",
        "public_id": "01a0101c-e3b5-71cb-a21b-34f349424cbf",
        "storage_key": "property/6767906449167590/01a0101c-e3b5-71cb-a21b-34f349424cbf.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Living Area With Kitchen at Cambria Luxury Apartment Homes, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f467aa1c470e52ccb6756aa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091599",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4a40c988a8ed39e3bb1a507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091601",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d6786c06fb962429e6eacfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091606",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3009975a703a8e6f0580669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091595",
      "title": "Cable-Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fd3240e2cc5c34b4286ac14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091611",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cd08fd2bd9909346a5bd6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091597",
      "title": "Central Air/Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03eb0c2103af387a4cb69735",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091610",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_581b4515f4731f8bc02e5446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091596",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ee7d-71ac-a5d8-8d5752958a4a.webp",
      "amenity_image_media": {
        "alt_text": "Cozy bedroom with a comfortable bed, a stylish armchair, and a large window.",
        "public_id": "01a0101c-ee7d-71ac-a5d8-8d5752958a4a",
        "storage_key": "property/6767906449167590/01a0101c-ee7d-71ac-a5d8-8d5752958a4a.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Spacious Bedroom at Cambria Luxury Apartment Homes, Missouri, 64112",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19c800168e5851ce8ee165f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091603",
      "title": "Kitchen Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef7f5764fbdac33ee29a63b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091594",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f577-7491-9871-76e1b295a260.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room and kitchen with a TV, sofa, and bar stools.",
        "public_id": "01a0101c-f577-7491-9871-76e1b295a260",
        "storage_key": "property/6767906449167590/01a0101c-f577-7491-9871-76e1b295a260.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Living Room And Kitchen at Cambria Luxury Apartment Homes, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_524e231ac81d6e633285cc9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091592",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_375cdfd18b87da7d5eb0ac4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091609",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ffa3-7516-816b-19698657e19c.webp",
      "amenity_image_media": {
        "alt_text": "Studio apartment bedroom with a king-size bed, closet, and open-concept kitchen with bar seating.",
        "public_id": "01a0101c-ffa3-7516-816b-19698657e19c",
        "storage_key": "property/6767906449167590/01a0101c-ffa3-7516-816b-19698657e19c.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Studio Kitchen at Cambria Luxury Apartment Homes, Kansas City, MO 64112",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c3fe0dd134ca6be5fbae3e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091605",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7be2edbe5dd8d95d324772ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091604",
      "title": "Plaza View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f697-730f-ba47-742fb2acde6e.webp",
      "amenity_image_media": {
        "alt_text": "View of a bustling urban neighborhood with a mix of residential and commercial buildings, street traffic, and distant trees under a bright blue sky.",
        "public_id": "01a0101c-f697-730f-ba47-742fb2acde6e",
        "storage_key": "property/6767906449167590/01a0101c-f697-730f-ba47-742fb2acde6e.webp",
        "width": 1510,
        "height": 1006
      },
      "amenity_image_alt_text": "view outside at Cambria Apartments , Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dedf56c728ee5d07c6fb5e75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091607",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c273ce113eded4e65b5aea5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "yardi",
      "external_id": "88091602",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_fc19500d7a9862bd6a449d0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-a7e9-7779-a3ea-d59a5d5e3c24.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern furniture and decor.",
        "public_id": "01a17de8-a7e9-7779-a3ea-d59a5d5e3c24",
        "storage_key": "property/6767906449167590/01a17de8-a7e9-7779-a3ea-d59a5d5e3c24.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room seamlessly flowing into a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with modern furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Cozy Mid-Century Open-Plan Living Space.png"
    },
    {
      "id": "ec_36206794927d8c7bfe2e7135",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-c083-7608-97a7-4fb9fdeefd13.webp",
      "image_media": {
        "alt_text": "Living room with couch, armchair, coffee table, and TV.",
        "public_id": "01a17de8-c083-7608-97a7-4fb9fdeefd13",
        "storage_key": "property/6767906449167590/01a17de8-c083-7608-97a7-4fb9fdeefd13.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A beautifully furnished living room featuring a comfortable couch, stylish armchair, and modern entertainment center, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with couch, armchair, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Modern Living Room Retreat.png"
    },
    {
      "id": "ec_00d3c6249df27d75eb6d45d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-c07b-7279-8aaf-728c35dbea2b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a17de8-c07b-7279-8aaf-728c35dbea2b",
        "storage_key": "property/6767906449167590/01a17de8-c07b-7279-8aaf-728c35dbea2b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Explore this stylish kitchen featuring dark wood cabinetry, sleek stainless steel appliances, and elegant granite countertops, perfect for culinary adventures.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Modern Open-Concept Kitchen Living Area.png"
    },
    {
      "id": "ec_ec30909bb47b9ab6f225d140",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-bfd0-7529-a819-ee5159163df5.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of a luxury apartment with a navy sofa, leather armchairs, and a breakfast bar.",
        "public_id": "01a17de8-bfd0-7529-a819-ee5159163df5",
        "storage_key": "property/6767906449167590/01a17de8-bfd0-7529-a819-ee5159163df5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Beautifully appointed living room and open-concept kitchen featuring comfortable seating, a breakfast bar with bar stools, and modern appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen of a luxury apartment with a navy sofa, leather armchairs, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Ralph Lauren–Style Living Room.png"
    },
    {
      "id": "ec_e96de2eb6b3a582919f20c01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-c7fe-77cd-bcac-dd43e8cb83f7.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, seating area, and desk.",
        "public_id": "01a17de8-c7fe-77cd-bcac-dd43e8cb83f7",
        "storage_key": "property/6767906449167590/01a17de8-c7fe-77cd-bcac-dd43e8cb83f7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant seating area, and a dedicated workspace, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, seating area, and desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Modern Olive-Toned Bedroom Suite.png"
    },
    {
      "id": "ec_5d560617ad02aefbf3e4b327",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-c031-7720-b95b-1a8e6b86c9be.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, walk-in closet, and a desk by the window.",
        "public_id": "01a17de8-c031-7720-b95b-1a8e6b86c9be",
        "storage_key": "property/6767906449167590/01a17de8-c031-7720-b95b-1a8e6b86c9be.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample closet space, and a dedicated workspace with a desk and chair.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, walk-in closet, and a desk by the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Modern Bedroom Retreat.png"
    },
    {
      "id": "ec_f4255bb7d87696890097c8ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-dbf5-738b-a2e2-1e048930682e.webp",
      "image_media": {
        "alt_text": "Stylish studio apartment with a king-size bed, open-concept kitchen, and comfortable seating area.",
        "public_id": "01a17de8-dbf5-738b-a2e2-1e048930682e",
        "storage_key": "property/6767906449167590/01a17de8-dbf5-738b-a2e2-1e048930682e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious studio apartment. Featuring a comfortable king-size bed, a fully equipped open-concept kitchen with bar seating, and a cozy living area, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Stylish studio apartment with a king-size bed, open-concept kitchen, and comfortable seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Neutral Studio Apartment Retreat.png"
    },
    {
      "id": "ec_dc9dfabe9330ddb306bb5cc8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-dc01-752c-8f7e-05374db73e98.webp",
      "image_media": {
        "alt_text": "Laundry room with dark cabinets, white washer and dryer, and decorative painting.",
        "public_id": "01a17de8-dc01-752c-8f7e-05374db73e98",
        "storage_key": "property/6767906449167590/01a17de8-dc01-752c-8f7e-05374db73e98.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious laundry room featuring dark wood cabinetry, ample counter space, and a full-size washer and dryer. The room is accented with a landscape painting and a floating shelf with plants.",
      "link": "false",
      "alt_text": "Laundry room with dark cabinets, white washer and dryer, and decorative painting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Warm Modern Laundry Room Retreat.png"
    },
    {
      "id": "ec_52c3f65c8663cfdaeea37d66",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-e27c-7239-806f-ba291bfe2502.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, plush armchair, and a walk-in closet.",
        "public_id": "01a17de8-e27c-7239-806f-ba291bfe2502",
        "storage_key": "property/6767906449167590/01a17de8-e27c-7239-806f-ba291bfe2502.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our beautifully appointed bedrooms, featuring spacious layouts and elegant furnishings.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, plush armchair, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Cozy Navy and Brass Bedroom Retreat.png"
    },
    {
      "id": "ec_6dbd228452fb610a46454d63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-dd7e-71f3-bc86-d407d9d4feb8.webp",
      "image_media": {
        "alt_text": "Modern living room with navy sofa, leather chairs, coffee table, and artwork.",
        "public_id": "01a17de8-dd7e-71f3-bc86-d407d9d4feb8",
        "storage_key": "property/6767906449167590/01a17de8-dd7e-71f3-bc86-d407d9d4feb8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stunning living room featuring a plush navy sofa, stylish leather accent chairs, and a modern coffee table, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Modern living room with navy sofa, leather chairs, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Navy Sofa Living Room with Leather Accents.png"
    },
    {
      "id": "ec_21455c54a16eef8f441ad71b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-dd10-759c-b83f-611bc8164e49.webp",
      "image_media": {
        "alt_text": "Building entrance with columns and arched entryway, featuring a Cambria Luxury Rentals sign.",
        "public_id": "01a17de8-dd10-759c-b83f-611bc8164e49",
        "storage_key": "property/6767906449167590/01a17de8-dd10-759c-b83f-611bc8164e49.webp",
        "width": 1140,
        "height": 759
      },
      "title": "Community",
      "description": "Elegant building entrance with classical columns and an arched entryway, complemented by lush landscaping and a prominent Cambria Luxury Rentals sign, welcoming residents home.",
      "link": "false",
      "alt_text": "Building entrance with columns and arched entryway, featuring a Cambria Luxury Rentals sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2ca-amenities-10(1).jpg"
    },
    {
      "id": "ec_5415f3695f67fceb495e0216",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a17de8-f0e9-71c9-84d5-a063010aab05.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a covered parking garage.",
        "public_id": "01a17de8-f0e9-71c9-84d5-a063010aab05",
        "storage_key": "property/6767906449167590/01a17de8-f0e9-71c9-84d5-a063010aab05.webp",
        "width": 1140,
        "height": 759
      },
      "title": "Community",
      "description": "View the exterior of our apartment buildings, featuring private balconies and convenient covered parking.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and a covered parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2ca-amenities-17(1).png"
    },
    {
      "id": "ec_9069406b7920a917a04b2fd1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-238e-741a-bc5d-969e48ed2915.webp",
      "image_media": {
        "alt_text": "Hallway with elevators and exit signs",
        "public_id": "01a0101d-238e-741a-bc5d-969e48ed2915",
        "storage_key": "property/6767906449167590/01a0101d-238e-741a-bc5d-969e48ed2915.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Well-lit hallway featuring modern elevators and clear exit signage, leading to other areas of the building.",
      "link": "false",
      "alt_text": "Hallway with elevators and exit signs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Cambria Luxury Apartments - 18.jpg"
    },
    {
      "id": "ec_bddc96f76c52ec083eddc58a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-4af3-72b0-b17c-2a82453d3081.webp",
      "image_media": {
        "alt_text": "View of a bustling street with historic buildings and trees.",
        "public_id": "01a0101d-4af3-72b0-b17c-2a82453d3081",
        "storage_key": "property/6767906449167590/01a0101d-4af3-72b0-b17c-2a82453d3081.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Experience the vibrant community atmosphere with charming streets and lively architecture.",
      "link": "false",
      "alt_text": "View of a bustling street with historic buildings and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Cambria Luxury Apartments - 21.jpg"
    },
    {
      "id": "ec_2a0f5207641f0869d20c8215",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-56ad-7441-9a5a-aa03e22fad03.webp",
      "image_media": {
        "alt_text": "The iconic Country Club Plaza Time & Space Building tower with its distinctive yellow dome and clock faces.",
        "public_id": "01a0101d-56ad-7441-9a5a-aa03e22fad03",
        "storage_key": "property/6767906449167590/01a0101d-56ad-7441-9a5a-aa03e22fad03.webp",
        "width": 1365,
        "height": 2048
      },
      "title": "Community",
      "description": "Admire the unique architecture of the Country Club Plaza's Time & Space Building, a landmark that adds historical charm and visual appeal to the community.",
      "link": "false",
      "alt_text": "The iconic Country Club Plaza Time & Space Building tower with its distinctive yellow dome and clock faces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/img_0963.jpg"
    },
    {
      "id": "ec_cbc71389eab6509196136a17",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp",
      "image_media": {
        "alt_text": "Exterior view of Cambria Apartments building with a parking garage entrance.",
        "public_id": "01a0101d-5586-757c-8ceb-38ca48ba8909",
        "storage_key": "property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp",
        "width": 1800,
        "height": 1199
      },
      "title": "Community",
      "description": "Exterior view of the Cambria Apartments building, showcasing its architecture and an integrated parking garage.",
      "link": "false",
      "alt_text": "Exterior view of Cambria Apartments building with a parking garage entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DJI_0169.jpg"
    },
    {
      "id": "ec_a0a6151ff9d166d246a28f16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-5582-777f-9b91-971d1aefc13c.webp",
      "image_media": {
        "alt_text": "A cityscape view with apartment buildings and commercial spaces under a cloudy blue sky.",
        "public_id": "01a0101d-5582-777f-9b91-971d1aefc13c",
        "storage_key": "property/6767906449167590/01a0101d-5582-777f-9b91-971d1aefc13c.webp",
        "width": 2200,
        "height": 1467
      },
      "title": "Community",
      "description": "Explore the vibrant cityscape surrounding the community, featuring a mix of residential and commercial buildings, all under a beautiful blue sky with fluffy clouds.",
      "link": "false",
      "alt_text": "A cityscape view with apartment buildings and commercial spaces under a cloudy blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7915(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b16f53c2-fb48-4819-8000-f53a288e3793",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Plaza",
      "poi_type": "Restaurants",
      "poi_address": "4747 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-39a1-708d-9c0d-8f234f674e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-39a1-708d-9c0d-8f234f674e38",
        "storage_key": "property/6767906449167590/019fc927-39a1-708d-9c0d-8f234f674e38.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=497015801065317704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---plaza",
      "poi_latitude": "39.0412556",
      "poi_longitude": "-94.5886417",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-531-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYjixLjvwIcRSCVB3jzB5QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_7fd39bbe-4b57-4bd5-a338-87cb3362c06a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "4701 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1fc-731f-a9b5-457cab24a4a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d1fc-731f-a9b5-457cab24a4a2",
        "storage_key": "property/6767906449167590/01a0101c-d1fc-731f-a9b5-457cab24a4a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/mo/kansas-city-17.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=18256206695721676157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "39.0420622",
      "poi_longitude": "-94.5885588",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-960-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxDuyLjvwIcRfS2ZpEMTW_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_91f71db5-24a3-45d7-b09e-532691f5ccb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "222 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1a8-768b-80ec-a9ff2aad1c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d1a8-768b-80ec-a9ff2aad1c5f",
        "storage_key": "property/6767906449167590/01a0101c-d1a8-768b-80ec-a9ff2aad1c5f.webp",
        "width": 1280,
        "height": 779
      },
      "poi_business_url": "https://fogodechao.com/location/kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7229289636537500349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "39.042487",
      "poi_longitude": "-94.5899538",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-931-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzU0krjvwIcRvQI7PJ-YU2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_bdfeea19-294e-4194-91e2-18c862d90128",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Winstead's Steakburgers",
      "poi_type": "Restaurants",
      "poi_address": "101 Emanuel Cleaver II Blvd., Kansas City, MO 64112, USA",
      "poi_short_description": "Old-fashioned American diner serving burgers, soda-fountain treats & breakfast since 1940.",
      "poi_long_description": "Old-fashioned American diner serving burgers, soda-fountain treats & breakfast since 1940.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1ac-72de-b92e-2aa13db91c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d1ac-72de-b92e-2aa13db91c8a",
        "storage_key": "property/6767906449167590/01a0101c-d1ac-72de-b92e-2aa13db91c8a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://winsteadssteakburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11179138956174568571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winsteads-steakburgers",
      "poi_latitude": "39.0418588",
      "poi_longitude": "-94.5854477",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSXIp7_vwIcReyyEqaZHJJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_36612b2a-6f45-4256-9287-2d9f1b5f7369",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Q39 - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1000 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_long_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-62d8-77e1-ac7b-8ebd9fe78c98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-62d8-77e1-ac7b-8ebd9fe78c98",
        "storage_key": "property/6767906449167590/019fc923-62d8-77e1-ac7b-8ebd9fe78c98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://q39kc.com/locations/kansas-city-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504754235694060525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---midtown",
      "poi_latitude": "39.0573424",
      "poi_longitude": "-94.5982173",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-255-3753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ541xZ9HvwIcR7RNf2s_QZEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8072c510-90b4-4659-af13-55199f288505",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Beer Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "435 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Creative American comfort food & craft beers delivered in bustling, stylish digs.",
      "poi_long_description": "Creative American comfort food & craft beers delivered in bustling, stylish digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-3a05-71bc-8c06-08821f471bb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-3a05-71bc-8c06-08821f471bb4",
        "storage_key": "property/6767906449167590/019fc927-3a05-71bc-8c06-08821f471bb4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://beerkitchenkc.com/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17183786019647604906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beer-kitchen",
      "poi_latitude": "39.0527781",
      "poi_longitude": "-94.5911822",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-389-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-8289-72ba-a68e-8d97ddd9cc5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-8289-72ba-a68e-8d97ddd9cc5d",
        "storage_key": "property/6767906449167590/019fc927-8289-72ba-a68e-8d97ddd9cc5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YhmJMXvwIcRqkhrXVcSee4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_aadb9fc6-fa4f-47bd-9480-9a16d0936257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Green Room Burgers & Beer L.L.C.",
      "poi_type": "Restaurants",
      "poi_address": "4010 Pennsylvania Ave Suite D, Kansas City, MO 64111, USA",
      "poi_short_description": "Organic burgers, sandwiches, local beers & hand-cut fries in a cozy pub setting.",
      "poi_long_description": "Organic burgers, sandwiches, local beers & hand-cut fries in a cozy pub setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-462f-700d-98e2-91e7970884bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-462f-700d-98e2-91e7970884bf",
        "storage_key": "property/6767906449167590/019fc927-462f-700d-98e2-91e7970884bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://facebook.com/greenroomkc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1403496285785470667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-room-burgers--beer-llc",
      "poi_latitude": "39.0545223",
      "poi_longitude": "-94.593265",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-216-7682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_Klp9rvwIcRy7bSlW84ehM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_930079e7-7e06-4bbc-9b6a-e68f94b00e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Cupini's",
      "poi_type": "Restaurants",
      "poi_address": "1809 Westport Rd Ste 200, Kansas City, MO 64111, USA",
      "poi_short_description": "Cozy counter serves up Italian staples including pasta, pizza & panini in a laid-back setting.",
      "poi_long_description": "Cozy counter serves up Italian staples including pasta, pizza & panini in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-3f70-77b8-96c6-a828610e79df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-3f70-77b8-96c6-a828610e79df",
        "storage_key": "property/6767906449167590/019fc927-3f70-77b8-96c6-a828610e79df.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://cupinis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14730648302848338824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cupinis",
      "poi_latitude": "39.0500063",
      "poi_longitude": "-94.6069918",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-753-7662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_y8DsDPuwIcRiGt8ypXGbcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_01d6672d-d682-4403-a376-ef162ab8a84a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Filling Station Coffee | Westport",
      "poi_type": "Restaurants",
      "poi_address": "1010 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Coffeehouse beverages & creative food options in a trendy venue with a light-filled atmosphere.",
      "poi_long_description": "Coffeehouse beverages & creative food options in a trendy venue with a light-filled atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-41e8-705f-96f4-385bcb482a2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-41e8-705f-96f4-385bcb482a2f",
        "storage_key": "property/6767906449167590/019fc927-41e8-705f-96f4-385bcb482a2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fillingstationcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9993246586580430640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "filling-station-coffee--westport",
      "poi_latitude": "39.0506915",
      "poi_longitude": "-94.598112",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-960-6448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-8289-72ba-a68e-8bd09a8c0250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-8289-72ba-a68e-8bd09a8c0250",
        "storage_key": "property/6767906449167590/019fc927-8289-72ba-a68e-8bd09a8c0250.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJD8ojnM7vwIcRMO8C8tIkr4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_ea8a995c-48d8-4689-88e4-735ac39817d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Thou Mayest - Nelson-Atkins",
      "poi_type": "Restaurants",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Museum cafe serving a variety of coffee drinks including lattes, alongside teas and baked goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d1b7-7731-97f2-f682580221fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d1b7-7731-97f2-f682580221fe",
        "storage_key": "property/6767906449167590/01a0101c-d1b7-7731-97f2-f682580221fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thoumayest.com/pages/thou-mayest-nelson-atkins",
      "poi_directions_map_url": "https://maps.google.com/?cid=14654403216834807533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thou-mayest---nelson-atkins",
      "poi_latitude": "39.0456355",
      "poi_longitude": "-94.5801998",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-897-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-8289-72ba-a68e-8bd09a8c0250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-8289-72ba-a68e-8bd09a8c0250",
        "storage_key": "property/6767906449167590/019fc927-8289-72ba-a68e-8bd09a8c0250.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJx3Y32OrvwIcR7cbHVhXmXss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_2385da95-444f-4ff2-9e8d-0e585c3701e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Lidia’s",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_long_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-cf9e-716a-864d-053b8232d33a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-cf9e-716a-864d-053b8232d33a",
        "storage_key": "property/6767906449167590/01a0101c-cf9e-716a-864d-053b8232d33a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.lidias-kc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14489280469360899567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidias",
      "poi_latitude": "39.0877163",
      "poi_longitude": "-94.5847287",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-221-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcR7_VCw9FDFMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b967a627-d02e-442e-af23-bd48e6adeef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Grünauer",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Austrian-German cooking & European beer in the historic dark-wood-&-brick Freight House space.",
      "poi_long_description": "Austrian-German cooking & European beer in the historic dark-wood-&-brick Freight House space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d9de-737d-bee8-06ffaf81ac04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d9de-737d-bee8-06ffaf81ac04",
        "storage_key": "property/6767906449167590/01a0101c-d9de-737d-bee8-06ffaf81ac04.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.grunauerkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11232384842969443421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grnauer",
      "poi_latitude": "39.0873431",
      "poi_longitude": "-94.5852782",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-283-3234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcRXeyswYBy4Zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "austrian_restaurant"
    },
    {
      "id": "custom_f9c212f1-6b7a-4f41-8ee9-cbbd02ae114d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Gram & Dun",
      "poi_type": "Restaurants",
      "poi_address": "600 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_long_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d782-71bb-b973-abf95bc54d93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d782-71bb-b973-abf95bc54d93",
        "storage_key": "property/6767906449167590/01a0101c-d782-71bb-b973-abf95bc54d93.webp",
        "width": 1280,
        "height": 917
      },
      "poi_business_url": "http://gramanddun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10690610804177532125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gram--dun",
      "poi_latitude": "39.0403087",
      "poi_longitude": "-94.5940799",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-389-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3HCerfvwIcR3XT0luKtXJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1244be0c-5232-4949-bb80-93dec8af2f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "The Granfalloon Restaurant And Bar",
      "poi_type": "Restaurants",
      "poi_address": "608 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "This bi-level bar & eatery boasts sports-tuned TVs, upscale pub fare & an open, casual dining room.",
      "poi_long_description": "This bi-level bar & eatery boasts sports-tuned TVs, upscale pub fare & an open, casual dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-3fef-7667-9742-6fa4031fcdb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-3fef-7667-9742-6fa4031fcdb0",
        "storage_key": "property/6767906449167590/019fc927-3fef-7667-9742-6fa4031fcdb0.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.thegranfalloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13162227725759642147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-granfalloon-restaurant-and-bar",
      "poi_latitude": "39.040159",
      "poi_longitude": "-94.594674",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-7850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnekLcLfvwIcRI3qzTmGgqbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9b3c65e8-d7a4-4cd4-bebe-18c1bea169bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Town Topic Hamburgers BROADWAY",
      "poi_type": "Restaurants",
      "poi_address": "2021 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Venerable restaurant (since the 1930s) serving burgers, shakes and pies in a hole-in-the-wall setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d659-7453-b3d2-af0582337f68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d659-7453-b3d2-af0582337f68",
        "storage_key": "property/6767906449167590/01a0101c-d659-7453-b3d2-af0582337f68.webp",
        "width": 1280,
        "height": 706
      },
      "poi_business_url": "http://towntopic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14985971370995172736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-topic-hamburgers-broadway",
      "poi_latitude": "39.0884514",
      "poi_longitude": "-94.5888061",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-842-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948c-73a9-ad04-3631a100a882",
        "storage_key": "property/6767906449167590/019fc923-948c-73a9-ad04-3631a100a882.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69u-z0bwwIcRgEVXFpDd-M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_d79596c0-5548-479d-b159-5c54506587f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3845 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-48d1-779a-ae49-884f040bad73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-48d1-779a-ae49-884f040bad73",
        "storage_key": "property/6767906449167590/019fc927-48d1-779a-ae49-884f040bad73.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3845+broadway+blvd-kansas+city-mo-64111/id=5278",
      "poi_directions_map_url": "https://maps.google.com/?cid=15848482437788268161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.05738789999999",
      "poi_longitude": "-94.5901947",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-561-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTrIudvvwIcRgfZi7c4e8ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_df0dd8d7-9fde-4a1b-9d0b-bcc29d445a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Apple Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "227 Nichols Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_long_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-d64a-7193-8ea6-9ce42a68a52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-d64a-7193-8ea6-9ce42a68a52e",
        "storage_key": "property/6767906449167590/01a0101c-d64a-7193-8ea6-9ce42a68a52e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.apple.com/retail/countryclubplaza?cid=aos-us-seo-maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7169769692986345739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apple-country-club-plaza",
      "poi_latitude": "39.0412072",
      "poi_longitude": "-94.5900441",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-448-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN3V8Q7jvwIcRCwnQd4wjgGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_28b92935-4253-48dc-ab27-02deeded491f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "14 W 62 Terrace, Kansas City, MO 64113, USA",
      "poi_short_description": "Relaxed supermarket selling organic eats, baked goods, wine and prepared dishes, with a salad bar, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-db67-733c-98eb-ec6ba6471759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-db67-733c-98eb-ec6ba6471759",
        "storage_key": "property/6767906449167590/01a0101c-db67-733c-98eb-ec6ba6471759.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13117215859270891575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "39.0150001",
      "poi_longitude": "-94.5888037",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-523-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9480-75db-b019-bff9d1430f66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9480-75db-b019-bff9d1430f66",
        "storage_key": "property/6767906449167590/019fc923-9480-75db-b019-bff9d1430f66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYPViQ7vwIcRNzj2dVO2CbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d38a7a2f-5a27-48ac-a018-81f70a4d7179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-63f2-7318-aef1-dd3dd84c75eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-63f2-7318-aef1-dd3dd84c75eb",
        "storage_key": "property/6767906449167590/019fc923-63f2-7318-aef1-dd3dd84c75eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/mo/kansas-city/720/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13718771023150469206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.9713402",
      "poi_longitude": "-94.6064342",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-333-5322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9480-75db-b019-bff9d1430f66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9480-75db-b019-bff9d1430f66",
        "storage_key": "property/6767906449167590/019fc923-9480-75db-b019-bff9d1430f66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJda3_VSbpwIcRVlDOdY_dYr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_69bafc09-c82b-440c-acf4-787699d22377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Made in KC Marketplace - Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "306 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Shops featuring locally sourced goods, including T-shirts, hats and home decor, plus a cafe and bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ddf1-731b-a3e6-34a70a91c8dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-ddf1-731b-a3e6-34a70a91c8dd",
        "storage_key": "property/6767906449167590/01a0101c-ddf1-731b-a3e6-34a70a91c8dd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.madeinkc.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12340124857014094327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "made-in-kc-marketplace---plaza",
      "poi_latitude": "39.0426967",
      "poi_longitude": "-94.5905537",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-718-0806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJYXq_NPvwIcR9wlLOi3uQKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_4781e92f-5adf-4ce7-b693-acd8507143ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "lululemon",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 Nichols Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "High-end yoga-focused chain featuring stylish athletic wear & accessories.",
      "poi_long_description": "High-end yoga-focused chain featuring stylish athletic wear & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-deb4-758b-81ff-62c6791a8328.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-deb4-758b-81ff-62c6791a8328",
        "storage_key": "property/6767906449167590/01a0101c-deb4-758b-81ff-62c6791a8328.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shop.lululemon.com/stores/us/kansas-city/kansascitymo?utm_source=organic&utm_medium=local_listings&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=7391775142633687207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lululemon",
      "poi_latitude": "39.0409997",
      "poi_longitude": "-94.591984",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-653-6483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0TAsk7jvwIcRp0g-NFTclGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sportswear_store"
    },
    {
      "id": "custom_2d1f4f2c-5f09-4e66-bd55-b49b1ea061df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "420 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019ff6c7-d080-7185-a4dd-16189045919a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-d080-7185-a4dd-16189045919a",
        "storage_key": "property/6767906449167590/019ff6c7-d080-7185-a4dd-16189045919a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2574",
      "poi_directions_map_url": "https://maps.google.com/?cid=6631116904486709165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "39.0425001",
      "poi_longitude": "-94.5920394",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-753-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ94TgE7jvwIcRracEBLF1Blw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_040dd476-27c8-41ac-8a75-b9664b9316bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "KC Style Haus",
      "poi_type": "Shopping & Retail",
      "poi_address": "4704 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-dee5-724d-babe-30883cd58f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-dee5-724d-babe-30883cd58f59",
        "storage_key": "property/6767906449167590/01a0101c-dee5-724d-babe-30883cd58f59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kcstylehaus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2829903536538397262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kc-style-haus",
      "poi_latitude": "39.0419632",
      "poi_longitude": "-94.5893802",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-255-3487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlQy4PT_vwIcRTir-40XWRSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_7a36d698-8d79-49f3-8f9e-70acd22306da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "SEPHORA",
      "poi_type": "Shopping & Retail",
      "poi_address": "424 Nichols Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_long_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-dd0b-70e7-acfb-817b33bf1adf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-dd0b-70e7-acfb-817b33bf1adf",
        "storage_key": "property/6767906449167590/01a0101c-dd0b-70e7-acfb-817b33bf1adf.webp",
        "width": 500,
        "height": 277
      },
      "poi_business_url": "https://www.sephora.com/happening/stores/country-club-plaza?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=7257188399226020647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sephora",
      "poi_latitude": "39.0416116",
      "poi_longitude": "-94.5925111",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-5996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcdtTMLjvwIcRJ-PzG2a2tmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_c4739c91-2f55-4c43-a190-20e196ad072a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4706 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_long_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019ff6c4-962b-726c-a95a-7927ae219eca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c4-962b-726c-a95a-7927ae219eca",
        "storage_key": "property/6767906449167590/019ff6c4-962b-726c-a95a-7927ae219eca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://countryclubplaza.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339093817016807577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-club-plaza",
      "poi_latitude": "39.0419692",
      "poi_longitude": "-94.5926089",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-753-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr4r_377vwIcRmXCBhXNEPas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6b2e8044-179d-4d81-9d6a-f1ea9c952705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Pembroke Hill School - Wornall Campus",
      "poi_type": "Education",
      "poi_address": "400 W 51st St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-4d23-70d3-b267-45bfa60968a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-4d23-70d3-b267-45bfa60968a7",
        "storage_key": "property/6767906449167590/019fc927-4d23-70d3-b267-45bfa60968a7.webp",
        "width": 1168,
        "height": 694
      },
      "poi_business_url": "http://www.pembrokehill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14098303887516842814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pembroke-hill-school---wornall-campus",
      "poi_latitude": "39.0358206",
      "poi_longitude": "-94.5931862",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-936-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdYvScLrvwIcRPjvzjrA8p8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_6cab6936-5553-4b07-a597-3dcd85399252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-6aae-7331-989f-505b97f91f56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-6aae-7331-989f-505b97f91f56",
        "storage_key": "property/6767906449167590/019fc923-6aae-7331-989f-505b97f91f56.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ba9b887c-3d2f-4f76-a47d-3c1073b99997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-698d-7229-877a-b5eb5901ecf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-698d-7229-877a-b5eb5901ecf2",
        "storage_key": "property/6767906449167590/019fc923-698d-7229-877a-b5eb5901ecf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c678cab3-8baa-4c99-bde1-bfd9bbaf9312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e021-7631-9833-32bb962dc3ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e021-7631-9833-32bb962dc3ba",
        "storage_key": "property/6767906449167590/01a0101c-e021-7631-9833-32bb962dc3ba.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_074701c5-d152-4d94-9592-b0f687834f06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "St. Teresa's Academy",
      "poi_type": "Education",
      "poi_address": "5600 Main St, Kansas City, MO 64113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-4de6-73bc-b94b-9956f7b73a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-4de6-73bc-b94b-9956f7b73a5d",
        "storage_key": "property/6767906449167590/019fc927-4de6-73bc-b94b-9956f7b73a5d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stteresasacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14340484779120538902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-teresas-academy",
      "poi_latitude": "39.0260311",
      "poi_longitude": "-94.588285",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-501-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS97r2qbvwIcRFjVgbu2iA8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6efe0f2d-b2d2-43cb-a7b5-a6b1be85ed05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Notre Dame de Sion",
      "poi_type": "Education",
      "poi_address": "3823 Locust St, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e3a2-70a2-bfd0-b872322ac207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e3a2-70a2-bfd0-b872322ac207",
        "storage_key": "property/6767906449167590/01a0101c-e3a2-70a2-bfd0-b872322ac207.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ndsion.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8735196018907781088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "notre-dame-de-sion",
      "poi_latitude": "39.0576456",
      "poi_longitude": "-94.5792126",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-753-3810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJxXEkubvwIcR4Jdnhn-mOXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9632ac37-8cfb-4d4f-b3f9-b83a1b018bcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Cristo Rey Kansas City",
      "poi_type": "Education",
      "poi_address": "211 Linwood Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e213-7731-9c78-b449011ce2e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e213-7731-9c78-b449011ce2e6",
        "storage_key": "property/6767906449167590/01a0101c-e213-7731-9c78-b449011ce2e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cristoreykc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11243391829905737682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cristo-rey-kansas-city",
      "poi_latitude": "39.0666903",
      "poi_longitude": "-94.5886139",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-457-6044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcUXP2ibwwIcR0ocPnEyNCJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c08263a5-38ce-492d-8ce7-a5aaf114c4bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Longfellow Elementary School",
      "poi_type": "Education",
      "poi_address": "2830 Holmes St, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://longfellow.kcpublicschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10246455806223039157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longfellow-elementary-school",
      "poi_latitude": "39.0747192",
      "poi_longitude": "-94.5770836",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-418-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3cPoCxrwwIcRtbqpiES5Mo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dc65bf23-4ee8-4045-9fb6-ab929d7d5466",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Edgar L. & Rheta A. Berkley Child & Family Development Center",
      "poi_type": "Education",
      "poi_address": "Berkley Child and Family Development Center, 1012 E 52nd St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://education.umkc.edu/berkley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9134193409455672109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgar-l--rheta-a-berkley-child--family-development-center",
      "poi_latitude": "39.032921",
      "poi_longitude": "-94.5739574",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-235-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsYnYjZrvwIcRLctRyIIsw34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_665b8f10-5d41-4c6a-a033-41257b307069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City University",
      "poi_type": "Education",
      "poi_address": "1750 Independence Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-6ab0-71f8-82a9-b7457ee6d75e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-6ab0-71f8-82a9-b7457ee6d75e",
        "storage_key": "property/6767906449167590/019fc923-6ab0-71f8-82a9-b7457ee6d75e.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://kansascity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16389816158537025495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-university",
      "poi_latitude": "39.1072822",
      "poi_longitude": "-94.5609759",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-654-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1greoD6wIcR14eOj_VSdOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d1221b32-0382-46fd-ad6e-4e5d700f02f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-71b3-7649-8312-b2f0c1964fd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-71b3-7649-8312-b2f0c1964fd9",
        "storage_key": "property/6767906449167590/019fc923-71b3-7649-8312-b2f0c1964fd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948e-73c3-a8b9-9b155eb3e030",
        "storage_key": "property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_fa2296da-231b-48ef-be60-392b17f02438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kemper Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_long_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-5236-72ae-84f6-4487bd5454b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-5236-72ae-84f6-4487bd5454b2",
        "storage_key": "property/6767906449167590/019fc927-5236-72ae-84f6-4487bd5454b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemperart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4417124555838519064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-museum-of-contemporary-art",
      "poi_latitude": "39.04643",
      "poi_longitude": "-94.5851292",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-753-5784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948e-73c3-a8b9-9b155eb3e030",
        "storage_key": "property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRGPdob2HHTD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_fbd63b64-cedb-49f4-ac72-688f065a528e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Uptown Theater KC",
      "poi_type": "Entertainment",
      "poi_address": "3700 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_long_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019ff6c7-d56b-7509-9609-9a9dc7d9f1cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-d56b-7509-9609-9a9dc7d9f1cf",
        "storage_key": "property/6767906449167590/019ff6c7-d56b-7509-9609-9a9dc7d9f1cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.uptowntheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846736320001238433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-theater-kc",
      "poi_latitude": "39.0611606",
      "poi_longitude": "-94.5907281",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-753-8665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm94AB9nvwIcRoWUYZDI2wAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wedding_venue"
    },
    {
      "id": "custom_5bddd0e5-afb9-4538-b976-4087b4aa6682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "American Jazz Museum",
      "poi_type": "Entertainment",
      "poi_address": "1616 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Museum devoted to jazz music with live performances, educational programs & interactive exhibits.",
      "poi_long_description": "Museum devoted to jazz music with live performances, educational programs & interactive exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-53d9-772b-b2cf-a0d2ad8c4f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-53d9-772b-b2cf-a0d2ad8c4f2e",
        "storage_key": "property/6767906449167590/019fc927-53d9-772b-b2cf-a0d2ad8c4f2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://americanjazzmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12153190234996580988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-jazz-museum",
      "poi_latitude": "39.0914549",
      "poi_longitude": "-94.5629526",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-474-8463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948e-73c3-a8b9-9b155eb3e030",
        "storage_key": "property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5V43AXbwwIcRfKK33CDOqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ec0249dc-a0de-477a-a160-69593b176596",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Negro Leagues Baseball Museum",
      "poi_type": "Entertainment",
      "poi_address": "1616 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_long_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-57b4-7282-bddd-1ddc58a8e2db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-57b4-7282-bddd-1ddc58a8e2db",
        "storage_key": "property/6767906449167590/019fc927-57b4-7282-bddd-1ddc58a8e2db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlbm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11911160217324044073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "negro-leagues-baseball-museum",
      "poi_latitude": "39.0913923",
      "poi_longitude": "-94.5626542",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-221-1920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948e-73c3-a8b9-9b155eb3e030",
        "storage_key": "property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YLPAHbwwIcRKT9dEBzxTKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_478b74e0-e2ae-4da7-9864-9a1311cd9ef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e46b-759d-81a1-ea2b685cdc11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e46b-759d-81a1-ea2b685cdc11",
        "storage_key": "property/6767906449167590/01a0101c-e46b-759d-81a1-ea2b685cdc11.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948e-73c3-a8b9-9b155eb3e030",
        "storage_key": "property/6767906449167590/019fc923-948e-73c3-a8b9-9b155eb3e030.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1b1bfbba-cd62-4d30-9754-9fc92ead387e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-5370-7189-825e-b05fdad419e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-5370-7189-825e-b05fdad419e0",
        "storage_key": "property/6767906449167590/019fc927-5370-7189-825e-b05fdad419e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0f182465-3a51-49b2-ac58-29f07d43a81f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "SEA LIFE Kansas City Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_long_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e6ca-7201-ad30-46b1d6b6d8f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e6ca-7201-ad30-46b1d6b6d8f2",
        "storage_key": "property/6767906449167590/01a0101c-e6ca-7201-ad30-46b1d6b6d8f2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.visitsealife.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590252280065768693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-kansas-city-aquarium",
      "poi_latitude": "39.0820805",
      "poi_longitude": "-94.5812573",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-471-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-fd64-7009-99ae-38cb00ebc372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101c-fd64-7009-99ae-38cb00ebc372",
        "storage_key": "property/6767906449167590/01a0101c-fd64-7009-99ae-38cb00ebc372.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJtyRwuxXwwIcR9TwjjtSQlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_9b91da38-bff6-4140-a862-3db3d60653b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "LEGOLAND Discovery Center Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd East Retail Suite 200; Crown Center Shops, Kansas City, MO 64108, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-5a76-733c-b30b-796dcc943f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-5a76-733c-b30b-796dcc943f02",
        "storage_key": "property/6767906449167590/019fc927-5a76-733c-b30b-796dcc943f02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206990507281059484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-kansas-city",
      "poi_latitude": "39.08208190000001",
      "poi_longitude": "-94.5813858",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-556-3958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq6ljwwIcRnI4Znq5fBGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_5615302b-b11e-40e7-bc2b-d7ec4973d82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "T-Mobile Center",
      "poi_type": "Entertainment",
      "poi_address": "1407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_long_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-58f3-77ca-b4b8-8760f2e2a467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-58f3-77ca-b4b8-8760f2e2a467",
        "storage_key": "property/6767906449167590/019fc927-58f3-77ca-b4b8-8760f2e2a467.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.t-mobilecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12445204140955467076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-center",
      "poi_latitude": "39.0974667",
      "poi_longitude": "-94.5801529",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-949-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi31tv2fwwIcRRP3eijo_tqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_4a1b3cce-d54d-42b3-b50f-f451da6ed9e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-5e13-7745-a9da-a80dd244c0ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-5e13-7745-a9da-a80dd244c0ba",
        "storage_key": "property/6767906449167590/019fc927-5e13-7745-a9da-a80dd244c0ba.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-kansas-city?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4012580085298393479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-of-kansas-city",
      "poi_latitude": "39.0460972",
      "poi_longitude": "-94.58992940000002",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-932-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9488-77a7-b9c4-07e2aa19dea5",
        "storage_key": "property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJembMcTvwIcRh3EE-VOMrzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_4ffcce4d-2591-48c2-83a7-d2c57ede93d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "St Luke's Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4320 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e8a9-7514-bb6b-e3d23dffe76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e8a9-7514-bb6b-e3d23dffe76d",
        "storage_key": "property/6767906449167590/01a0101c-e8a9-7514-bb6b-e3d23dffe76d.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "https://www.saintlukeskc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15437675138956743486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-plaza",
      "poi_latitude": "39.0483085",
      "poi_longitude": "-94.5894565",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-932-8663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6gVosbvwIcRPlNlH7-jPdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b3de3afd-e82c-4d48-b8f5-8e9529067e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital Outpatient Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e7da-756e-881e-8ae8b7943880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e7da-756e-881e-8ae8b7943880",
        "storage_key": "property/6767906449167590/01a0101c-e7da-756e-881e-8ae8b7943880.webp",
        "width": 300,
        "height": 300
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-outpatient-pharmacy?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13057927777405687286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-outpatient-pharmacy",
      "poi_latitude": "39.0486635",
      "poi_longitude": "-94.5907942",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-932-2188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-8287-752a-9ec1-97ec85d35c5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-8287-752a-9ec1-97ec85d35c5a",
        "storage_key": "property/6767906449167590/019fc927-8287-752a-9ec1-97ec85d35c5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbEajMbvwIcR9tX4MiEUN7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8c7f73fb-40c9-4702-a39c-f6e42a1441e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Albers Medical Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4400 Broadway St #106, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e989-773c-b028-0e7adc1b87fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e989-773c-b028-0e7adc1b87fe",
        "storage_key": "property/6767906449167590/01a0101c-e989-773c-b028-0e7adc1b87fe.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.alberspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2469964368664842582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albers-medical-pharmacy",
      "poi_latitude": "39.047298",
      "poi_longitude": "-94.591809",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-931-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-8287-752a-9ec1-97ec85d35c5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc927-8287-752a-9ec1-97ec85d35c5a",
        "storage_key": "property/6767906449167590/019fc927-8287-752a-9ec1-97ec85d35c5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XUrQsbvwIcRVtEjwoETRyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ac33fec8-ee48-4569-a21a-d05aa4eec94a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5011 Main St, Kansas City, MO 64112, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ea37-7125-b1f4-f1a0aba4555e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-ea37-7125-b1f4-f1a0aba4555e",
        "storage_key": "property/6767906449167590/01a0101c-ea37-7125-b1f4-f1a0aba4555e.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/5011-main-st-kansas-city-mo-64112/storeid=8567?WT.mc_id=LS_GOOGLE_FS_8567",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406075267570829173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.0360471",
      "poi_longitude": "-94.5868685",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-531-4699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEfH_ZrzvwIcRdYfBJutgqHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a615eb68-c554-43dd-926d-00b6acd5936c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Chiefs Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "612 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Membership-only gym in the Country Club Plaza featuring a sauna, classes, and motivating instructors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-e908-7308-ac4f-d8a47ffc8ffa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-e908-7308-ac4f-d8a47ffc8ffa",
        "storage_key": "property/6767906449167590/01a0101c-e908-7308-ac4f-d8a47ffc8ffa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://chiefsfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712496314265125622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chiefs-fit",
      "poi_latitude": "39.0426076",
      "poi_longitude": "-94.594501",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-914-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbLwysnvwIcR9kI8TAvca7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b54bc3b5-51a8-4308-bf8a-21bc68c9f230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "MOJO Cycling Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "4722 Broadway Blvd #220, Kansas City, MO 64112, USA",
      "poi_short_description": "Relaxed cycle studio (and occasional pop-up fitness center), with instructors leading full-body workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ed64-713d-887a-8e12585bb2d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-ed64-713d-887a-8e12585bb2d2",
        "storage_key": "property/6767906449167590/01a0101c-ed64-713d-887a-8e12585bb2d2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mojocyclingstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16145744172794144761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mojo-cycling-studio",
      "poi_latitude": "39.0416534",
      "poi_longitude": "-94.5917783",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-561-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_vDaLjvwIcR-We6Bcg0EeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_159f6df3-d41a-4661-98ee-37560bf89d6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "610 W 48th St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ed85-7069-aa7c-ac1cdbe70ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-ed85-7069-aa7c-ac1cdbe70ce0",
        "storage_key": "property/6767906449167590/01a0101c-ed85-7069-aa7c-ac1cdbe70ce0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/location/countryclubplaza/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052066117731006770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.040707",
      "poi_longitude": "-94.5944761",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-875-3226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN9vdDG_vwIcRMrnAUarUOzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a261a240-5a41-44af-abf3-f4a7cfa1b611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Spine and Joint Centers of America",
      "poi_type": "Health and Wellness",
      "poi_address": "800 W 47th St #100, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-ef61-749b-aa31-62a47595a4a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-ef61-749b-aa31-62a47595a4a6",
        "storage_key": "property/6767906449167590/01a0101c-ef61-749b-aa31-62a47595a4a6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://sjcoamo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753146990914238308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spine-and-joint-centers-of-america",
      "poi_latitude": "39.0426889",
      "poi_longitude": "-94.5966803",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-216-7054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXLbs-3vwIcRZPcsKVL-3L4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_da1a7967-421f-4e7c-834a-d6e7ad78900d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Power Life Yoga Barre Fitness - South Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Main St Ste G003, Kansas City, MO 64112, USA",
      "poi_short_description": "Fitness chain offering yoga, Pilates, barre, and sculpting classes, plus training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f0ee-73f9-92a5-b3f8ea8b2dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f0ee-73f9-92a5-b3f8ea8b2dd1",
        "storage_key": "property/6767906449167590/01a0101c-f0ee-73f9-92a5-b3f8ea8b2dd1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://powerlife.com/location/south-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15250793803416611395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power-life-yoga-barre-fitness---south-plaza",
      "poi_latitude": "39.0392193",
      "poi_longitude": "-94.5879346",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-541-3793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwpdsb7vwIcRQypgeym0pdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d0d44438-c912-4d11-bad0-29a015a8b27d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-801b-752f-8a61-4f62ad0aa643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-801b-752f-8a61-4f62ad0aa643",
        "storage_key": "property/6767906449167590/019fc923-801b-752f-8a61-4f62ad0aa643.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-96ef-73ae-b7e4-492e333026ff",
        "storage_key": "property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_93aca189-3a9e-481c-8c67-bc4caaec9bc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Mill Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 43rd St &, Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Relaxed outdoor spot featuring a circular walking track and a fountain, plus an array of workout equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-66fe-737d-9156-3525b7acae07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-66fe-737d-9156-3525b7acae07",
        "storage_key": "property/6767906449167590/019fc927-66fe-737d-9156-3525b7acae07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/mill-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=488052792635368784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-park",
      "poi_latitude": "39.0460414",
      "poi_longitude": "-94.5883526",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-96ef-73ae-b7e4-492e333026ff",
        "storage_key": "property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_VoTU3vwIcRUCWr2G3pxQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e6d653b0-c3e8-492c-bfac-95b31d1260c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Ward Parkway Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "Popular shopping center featuring familiar big-name stores (like Target and HomeGoods), eateries and gym options, as well as a movie theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019ff6c7-dd32-7216-9b0b-bc80ef3325e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-dd32-7216-9b0b-bc80ef3325e8",
        "storage_key": "property/6767906449167590/019ff6c7-dd32-7216-9b0b-bc80ef3325e8.webp",
        "width": 1280,
        "height": 1144
      },
      "poi_business_url": "http://www.wardparkwaycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12737272864935780034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ward-parkway-center",
      "poi_latitude": "38.9702054",
      "poi_longitude": "-94.606055",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-363-3545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-94cd-7339-90c3-52c7e153c50a",
        "storage_key": "property/6767906449167590/019fc923-94cd-7339-90c3-52c7e153c50a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp3psGfLpwIcRwh64iS_iw7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6fd4322b-7642-4545-aced-78952b025522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Brush Creek Greenway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4084-4200 Blue Pkwy, Kansas City, MO 64130, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f4d6-735b-a30c-74409b28ebb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f4d6-735b-a30c-74409b28ebb7",
        "storage_key": "property/6767906449167590/01a0101c-f4d6-735b-a30c-74409b28ebb7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcparks.org/places/brush-creek-greenway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16139355184988050431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brush-creek-greenway-park",
      "poi_latitude": "39.0365371",
      "poi_longitude": "-94.537776",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-96ef-73ae-b7e4-492e333026ff",
        "storage_key": "property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3VNPhLlwIcR_1MS4QeC-t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_051c780d-50ad-46e4-88db-0ddbc3f70176",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Gillham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3915 Gillham Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "Kid-friendly park featuring playgrounds and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-6219-730b-9f01-c0fcd21270de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-6219-730b-9f01-c0fcd21270de",
        "storage_key": "property/6767906449167590/019fc927-6219-730b-9f01-c0fcd21270de.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://kcparks.org/park/gillham-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4125589893627255631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gillham-park",
      "poi_latitude": "39.0539932",
      "poi_longitude": "-94.5788865",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-96ef-73ae-b7e4-492e333026ff",
        "storage_key": "property/6767906449167590/019fc923-96ef-73ae-b7e4-492e333026ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6GFpujvwIcRTxuYYiYKQTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ca5507fa-d716-4fac-b941-4529c928c321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "On 47th at Broadway Westbound Farside",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f7ac-76da-a70c-e5cbfd0eca36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f7ac-76da-a70c-e5cbfd0eca36",
        "storage_key": "property/6767906449167590/01a0101c-f7ac-76da-a70c-e5cbfd0eca36.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5737055051355889694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-47th-at-broadway-westbound-farside",
      "poi_latitude": "39.042437",
      "poi_longitude": "-94.591758",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-fd74-77bc-8ac8-eef4ac27649a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101c-fd74-77bc-8ac8-eef4ac27649a",
        "storage_key": "property/6767906449167590/01a0101c-fd74-77bc-8ac8-eef4ac27649a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9dxaabjvwIcRHqDtSCwdnk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_0033429a-3f2c-451f-9e54-4b4d9f2d9ee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "RideKC - 39th St & Troost Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3829 Troost Ave, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7289192013737135469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc---39th-st--troost-transit-center",
      "poi_latitude": "39.0563082",
      "poi_longitude": "-94.5718268",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-842-9070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUypIaHvwIcRbY1qRoRpKGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_71503b38-35cf-4c73-ad3b-c8b8ca1b4b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City BCycle: 4th & Delaware",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-6c0b-75bc-806e-fb47985c0956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-6c0b-75bc-806e-fb47985c0956",
        "storage_key": "property/6767906449167590/019fc927-6c0b-75bc-806e-fb47985c0956.webp",
        "width": 1280,
        "height": 1208
      },
      "poi_business_url": "http://ridekcbike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5895537421157557018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-bcycle-4th--delaware",
      "poi_latitude": "39.1088929",
      "poi_longitude": "-94.5845181",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-945-9545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9Dj4PTwwIcRGmMedAwo0VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bike_sharing_station"
    },
    {
      "id": "custom_5faf561a-d766-4cb0-ae41-5d4a5b2e6f7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-8be4-76f9-8e20-abed98610c87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-8be4-76f9-8e20-abed98610c87",
        "storage_key": "property/6767906449167590/019fc923-8be4-76f9-8e20-abed98610c87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-975a-72c5-8385-8aff2dc7820d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-975a-72c5-8385-8aff2dc7820d",
        "storage_key": "property/6767906449167590/019fc923-975a-72c5-8385-8aff2dc7820d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_4e168f71-aaf7-46f7-bb55-90f01875f526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-6adb-7786-b712-78912e143fa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-6adb-7786-b712-78912e143fa1",
        "storage_key": "property/6767906449167590/019fc927-6adb-7786-b712-78912e143fa1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "25.2",
      "poi_walking_minutes": "9 hours 26 mins",
      "poi_biking_minutes": "3 hours 5 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9755-7618-9258-617972f82b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9755-7618-9258-617972f82b54",
        "storage_key": "property/6767906449167590/019fc923-9755-7618-9258-617972f82b54.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_68f77a9f-2103-4ff6-a3cd-455b316be737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Kansas City 47Th St Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, KS 66102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986244376617175594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-47th-st-transit-center",
      "poi_latitude": "39.11365",
      "poi_longitude": "-94.68587",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-fd74-77bc-8ac8-eef4ac27649a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101c-fd74-77bc-8ac8-eef4ac27649a",
        "storage_key": "property/6767906449167590/01a0101c-fd74-77bc-8ac8-eef4ac27649a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJESfn8qfzwIcRKkra0I-M2t0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_eb8d7980-194a-4693-91f4-5dc164a656b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Stowers Institute for Medical Research",
      "poi_type": "Education",
      "poi_address": "1000 E 50th St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f3f8-757d-acb4-ac1055b44187.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f3f8-757d-acb4-ac1055b44187",
        "storage_key": "property/6767906449167590/01a0101c-f3f8-757d-acb4-ac1055b44187.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "http://www.stowers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14221194027749611628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stowers-institute-for-medical-research",
      "poi_latitude": "39.0365098",
      "poi_longitude": "-94.5742972",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-926-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-948b-762c-a176-5d4078caf092",
        "storage_key": "property/6767906449167590/019fc923-948b-762c-a176-5d4078caf092.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1aC1p5HvwIcRbBjsAZ_UW8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "custom_2fd33c45-8c07-4b8e-81ab-55756c8c45c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-839c-703a-8d6c-dbe7ec76a365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-839c-703a-8d6c-dbe7ec76a365",
        "storage_key": "property/6767906449167590/019fc923-839c-703a-8d6c-dbe7ec76a365.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9488-77a7-b9c4-07e2aa19dea5",
        "storage_key": "property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_07b2dda8-7ca1-48e1-a6ea-b3b6b6963cdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-6c17-76db-b968-5fd69cb061ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-6c17-76db-b968-5fd69cb061ee",
        "storage_key": "property/6767906449167590/019fc927-6c17-76db-b968-5fd69cb061ee.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9488-77a7-b9c4-07e2aa19dea5",
        "storage_key": "property/6767906449167590/019fc923-9488-77a7-b9c4-07e2aa19dea5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_673badcb-595f-46e7-b68a-bdeec775b67f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-8c3b-70fd-abe3-37678d724f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc923-8c3b-70fd-abe3-37678d724f0f",
        "storage_key": "property/6767906449167590/019fc923-8c3b-70fd-abe3-37678d724f0f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_94d5ff68-a4a1-4e7f-adb1-805d59c4961f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Federal Reserve Bank of Kansas City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Memorial Dr, Kansas City, MO 64198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-705f-7648-bf25-da497dc97031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-705f-7648-bf25-da497dc97031",
        "storage_key": "property/6767906449167590/019fc927-705f-7648-bf25-da497dc97031.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kansascityfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17710993233906432888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-kansas-city",
      "poi_latitude": "39.0753294",
      "poi_longitude": "-94.5858203",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-333-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-979f-725c-8318-f841a76f2452.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-979f-725c-8318-f841a76f2452",
        "storage_key": "property/6767906449167590/019fc923-979f-725c-8318-f841a76f2452.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9xf5TzwwIcRePtWZoIWyvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_e93a1e13-49d2-46fa-b1b3-ac1e88cdcf1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc927-6d2a-706d-a8ac-52061af1b034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc927-6d2a-706d-a8ac-52061af1b034",
        "storage_key": "property/6767906449167590/019fc927-6d2a-706d-a8ac-52061af1b034.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_049b8336-0869-4bdc-b46e-8545aa69fe04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "American Century Investments",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f489-706d-a1cc-01b3f94612c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f489-706d-a1cc-01b3f94612c1",
        "storage_key": "property/6767906449167590/01a0101c-f489-706d-a1cc-01b3f94612c1.webp",
        "width": 1280,
        "height": 389
      },
      "poi_business_url": "https://www.americancentury.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277441427661296472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-century-investments",
      "poi_latitude": "39.0459098",
      "poi_longitude": "-94.5874404",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-531-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ciW3sDvwIcRWJOucgQ9PUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_8cc2c6cd-49f1-468b-b8db-5ba192dcad17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "poi_name": "Burns & McDonnell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9400 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101c-f4d6-735b-a30c-733c508f404d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101c-f4d6-735b-a30c-733c508f404d",
        "storage_key": "property/6767906449167590/01a0101c-f4d6-735b-a30c-733c508f404d.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://www.burnsmcd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12200015508632981471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns--mcdonnell",
      "poi_latitude": "38.9581441",
      "poi_longitude": "-94.5989227",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-333-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc923-9499-7548-be46-3c76ec590ae6",
        "storage_key": "property/6767906449167590/019fc923-9499-7548-be46-3c76ec590ae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20Zyr-DowIcR309TdncpT6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d593d45d93ecd9e5f09317de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_697fa8ab986eba96f24c973f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b9dd20b739c52e4015e16e6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7e511fa1db56dd85b50ad919",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_647fac96d8a167c5cd4a1c09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_80fbcd1b5ec92b7af01d2d92",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "rating": "5",
      "name": "Nursing Student",
      "text": "Heather is hands down the best manager! She literally outdoes herself and we always notice her working late (she needs a vacation). I would describe Cambria Luxury Apartments as clean, safe, and an overall good investment in living arrangements. The maintenance staff are quick to respond to requests, the building is kept up-to-date. Bonuses are size of the apartments for the plaza, covered parking, washer & dryer in each unit, walking to shops and restaurants, and short walk to the Saint Lukes Plaza campus. The views are absolutely beautiful from the balconies & windows. So far, we have lived in a one-bedroom and two-bedroom and enjoyed them both.",
      "date": "2024-10-05",
      "title": "false"
    },
    {
      "id": "ec_94ca1655381202f12df2516c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "rating": "5",
      "name": "Jenifer Fitzgerald",
      "text": "Heather was absolutely wonderful throughout the entire leasing and move-in process. She was responsive, patient, and always willing to answer my many questions. She went above and beyond to coordinate with our movers and helped ensure everything went smoothly on move-in day.\n\nMoving can be stressful, but Heather made the experience easy and seamless. Her professionalism, kindness, and attention to detail were truly appreciated. Thank you, Heather, for all your help!",
      "date": "2026-05-31",
      "title": "false"
    },
    {
      "id": "ec_3c77d66a2fbf1ee27780d4e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "rating": "5",
      "name": "Madison Trout",
      "text": "My husband and I lived at Cambria for 3 years and loved every minute. Heather is always there with a smile and truly cares about each and every resident. Any question or request that we had was answered in a timely and attentive fashion. Cambria overall had great maintenance staff, clean living spaces, and was a wonderful community.",
      "date": "2026-03-05",
      "title": "false"
    },
    {
      "id": "ec_8c17e12691cef9a8c07a4ec1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "rating": "5",
      "name": "Chad Kehrley",
      "text": "I moved to Kansas City for work and stayed at Cambria in an Airbnb unit for a couple of weeks while looking for an apartment. Enjoyed the quiet atmosphere in the building and short walk to Plaza restaurants and shops, so decided to lease a studio here. Balcony is great, full size washer/dryer, dishwasher and refrigerator make for easy daily living. Electronic entry to parking, building and elevators is easy and secure. Assigned parking is a big plus in this area of town!",
      "date": "2020-07-26",
      "title": "false"
    },
    {
      "id": "ec_75fd3b2310319a493adff7f3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "rating": "5",
      "name": "Qiyang Lian",
      "text": "This might be the only place where you can overlook the entire Plaza and have direct sunlight in your rooms. It is professionally maintained. The management team is beyond helpful. I requested servicing three times in the past. All problems were fixed the next business day. The only reason I would move out is me getting a house. Cambria is perfect.",
      "date": "2020-09-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_92be306e-8a2f-4805-a9a6-b4348b7e201d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "1-bedroom apartment near Country Club plaza at Cambria Luxury Apartment Homes in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-809e-711f-9bff-b72da5cbcd6d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101d-809e-711f-9bff-b72da5cbcd6d",
        "storage_key": "property/6767906449167590/01a0101d-809e-711f-9bff-b72da5cbcd6d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "MONTEREY A1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cukSY3UkScx"
    },
    {
      "id": "custom_f82bfb5a-2474-4ca3-af02-b3f28aba2d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "1-bedroom apartment near Country Club plaza at Cambria Luxury Apartment Homes in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-8062-76ff-9042-908b8093712b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101d-8062-76ff-9042-908b8093712b",
        "storage_key": "property/6767906449167590/01a0101d-8062-76ff-9042-908b8093712b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "MERLOT A5",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tHYKPQiyYja"
    },
    {
      "id": "custom_58726916-78e5-410e-8a61-129c6c2b3201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "2-bedroom apartment near Country Club plaza at Cambria Luxury Apartment Homes in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-81b9-76be-8814-d313112ff165.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101d-81b9-76be-8814-d313112ff165",
        "storage_key": "property/6767906449167590/01a0101d-81b9-76be-8814-d313112ff165.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "TOSCANO",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g1MKTsFNDk4"
    },
    {
      "id": "custom_4083eeb2-46c6-4022-8a32-29d8d2e06351",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "2-bedroom apartment near Country Club plaza at Cambria Luxury Apartment Homes in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-8d32-70d8-ba10-7a95b73418a9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101d-8d32-70d8-ba10-7a95b73418a9",
        "storage_key": "property/6767906449167590/01a0101d-8d32-70d8-ba10-7a95b73418a9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "MOSCATO",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7LTeWbCyoRm"
    },
    {
      "id": "custom_f76c311a-8829-4982-be09-c67d71b4ae1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a01686-92b1-73dd-90ef-03676e340ca0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01686-92b1-73dd-90ef-03676e340ca0",
        "storage_key": "property/6767906449167590/01a01686-92b1-73dd-90ef-03676e340ca0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Staged Cabernet Studio - Cambria Luxury Apartment Homes",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Tip2v57HtAp"
    }
  ],
  "faqs": [
    {
      "id": "custom_5479a272-c53b-4cbe-8475-bfd3b7f14562",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_4e021be3-6975-4ce0-875d-20ea6ead80ab",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_558ff5ec-59b8-406e-b3fc-77b16cbae397",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_126c10b6-25cc-4629-8974-2a55bd6a1f84",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_4e2ebbd7-7bca-4f1b-b124-47bca582cd70",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_b3d37701-1e37-4aab-8dae-603385889220",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_579e962b-f8fe-4a7c-9035-ca4839944935",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_684388be-6f73-468b-83f8-61bbed8ff1d2",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f1bf55d6-1d34-47b0-bace-b91943da222f",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_ea3c9874-828f-4a83-b4fa-7c4401b48959",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_298ba75f-2c12-49a0-a39f-6d6c61a7f4a2",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b9b00533-a29d-41cb-8465-184fb330b964",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer partially covered, uncovered, and covered parking. Covered parking is based on availability. One parking space is included with every apartment home. Additional spaces are available for rent. Please <a href=\"/contact-us\">contact our leasing office</a> for availibility and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_4d744298-6081-4308-9c4b-3270717860ce",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_33bd9627-1a9a-4851-b090-e7b8989a91b7",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_1386b3a6-83bb-4078-947e-bd9f0c3430ce",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-2b04-70ab-ad7d-d18e47077c0d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cambria Luxury Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590"
    },
    {
      "lead_collector_id": "01a0c9ac-2be1-72e7-9d86-b718686ec444",
      "lead_source": "LANDING_PAGE",
      "name": "Cambria Luxury Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "luxury-apartments-in-unit-laundry-kansas-city-mo",
      "search_query": "luxury apartments with in-unit laundry kansas city mo",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover premium living with in-unit laundry facilities in Kansas City, MO. Experience the convenience offered by Cambria Luxury Apartment Homes.",
      "page_copy": "Experience the height of comfort and convenience at Cambria Luxury Apartment Homes in Kansas City, MO. Our spacious studio, one-, and two-bedroom floor plans feature in-unit laundry, providing a convenient and luxurious living solution. Situated in the vibrant Plaza Area, our community enhances your lifestyle with easy access to premier shopping and dining.\n\nCambria Luxury Apartment Homes isn't just about location – it's about elevating everyday living. Enjoy sophisticated interiors, select double balconies, and a suite of amenities including efficient appliances and recycling services. Visit us to see why our luxury apartments with in-unit laundry are the preferred choice for Kansas City residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments in Kansas City | In-Unit Laundry",
      "seo_description": "Find luxury apartments with in-unit laundry in Kansas City, MO at Cambria. Enjoy Plaza views and premium amenities in an upscale setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-plaza-area-kc",
      "search_query": "dishwasher equipped apartments plaza area kansas city",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Plaza Area",
      "h2_subtitle": "Find apartments equipped with dishwashers in the vibrant Plaza Area of Kansas City. Cambria Luxury Apartment Homes offers modern convenience.",
      "page_copy": "At Cambria Luxury Apartment Homes, located in Kansas City’s vibrant Plaza Area, luxury and convenience unite in perfect harmony. Each of our studio, one-, and two-bedroom apartments is thoughtfully designed and includes a dishwasher, making everyday life simpler and more enjoyable. Beyond the modern appliances, residents enjoy easy access to an array of high-end shopping and dining options just moments away.\n\nBeyond equipped kitchens, experience the refined comfort of living amidst polished finishes, in-home laundry, and select units featuring spacious double balconies. Our community offers a guest apartment for visitors, along with essential amenities like recycling services. Cambria is the ideal choice for those seeking dishwasher-equipped apartments in the heart of Kansas City’s Plaza Area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments in Plaza Area, KC",
      "seo_description": "Discover dishwasher-equipped apartments at Cambria in the Plaza Area, Kansas City. Enjoy luxury with convenient amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartment-dedicated-parking-jackson-county",
      "search_query": "apartment with dedicated parking jackson county",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking",
      "h2_subtitle": "Find an apartment with dedicated parking in Jackson County at Cambria Luxury Apartment Homes. Enjoy premium amenities in a desirable location.",
      "page_copy": "Cambria Luxury Apartment Homes in Jackson County offers more than just stylish interiors and modern conveniences. We understand the importance of hassle-free living, which is why our residents have access to dedicated parking, ensuring you always have a spot waiting for you when you return home. Nestled in Kansas City's sought-after Plaza Area, our community combines upscale living with practical features.\n\nOur beautifully designed studio, one-, and two-bedroom apartments come with polished finishes, in-home laundry, and select double balconies. As a resident of Cambria, you'll benefit from convenient access to upscale shopping and dining, along with amenities like recycling services and a guest apartment. Embrace the comfort and ease of living in a Cambria apartment with dedicated parking in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Apartments | Dedicated Parking",
      "seo_description": "Secure your apartment with dedicated parking in Jackson County at Cambria. Enjoy convenient living with premium amenities in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "air-conditioned-luxury-apartments-kansas-city-64112",
      "search_query": "air conditioned luxury apartments kansas city 64112",
      "category": "Amenity",
      "h1_title": "Air Conditioned Luxury Apartments in KC",
      "h2_subtitle": "Discover air conditioned luxury apartments in Kansas City, 64112. Enjoy comfort and convenience at Cambria Luxury Apartment Homes.",
      "page_copy": "Experience the ultimate in comfort at Cambria Luxury Apartment Homes, located in the heart of Kansas City, 64112. Our luxury apartments are fully air-conditioned, providing a comfortable retreat during every season. Nestled in the prominent Plaza Area, our community offers an exceptional living experience with spacious studio, one-, and two-bedroom floor plans boasting elevated finishes and in-home laundry.\n\nResidents of Cambria enjoy unparalleled access to local shopping and dining scenes, along with the benefits of modern amenities such as select units with double balconies, guest apartment availability, and essential services like recycling. Embrace a lifestyle of convenience and sophistication by choosing an air conditioned luxury apartment at Cambria in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Luxury Apartments in KC, 64112",
      "seo_description": "Find air conditioned luxury apartments in Kansas City, 64112 at Cambria. Enjoy modern amenities and a prime location in the Plaza Area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "balcony-view-apartments-near-plaza-shopping-kc",
      "search_query": "balcony view apartments near plaza shopping kansas city",
      "category": "Amenity",
      "h1_title": "Balcony View Apartments Near Plaza Shopping",
      "h2_subtitle": "Explore balcony view apartments near Plaza shopping in Kansas City. Cambria Luxury Apartment Homes offers stunning views and prime convenience.",
      "page_copy": "Situated near the iconic Plaza shopping district, Cambria Luxury Apartment Homes in Kansas City offers an unparalleled living experience with stunning balcony views. Our select units feature spacious double balconies, providing residents with breathtaking vistas of the vibrant cityscape. This perfect blend of luxury and location ensures that you're just moments away from high-end shopping and dining.\n\nOur elegant studio, one-, and two-bedroom apartments boast polished finishes and in-home laundry, combining convenience with comfort. Residents can take advantage of community amenities such as a guest apartment and recycling services. Elevate your lifestyle by choosing a balcony view apartment near Plaza shopping, where modern living and convenience meet at Cambria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Balcony View Apts Near Plaza Shopping, KC",
      "seo_description": "Discover balcony view apartments near Plaza shopping in Kansas City at Cambria. Enjoy stunning views and luxury living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "studio-apartments-kansas-city-mo-cambria",
      "search_query": "studio apartments kansas city mo",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Kansas City, MO",
      "h2_subtitle": "Explore studio apartments in Kansas City, MO at Cambria Luxury Apartment Homes. Modern living with refined finishes awaits.",
      "page_copy": "Discover exquisite studio apartments at Cambria Luxury Apartment Homes, ideally located in Kansas City, MO. Our thoughtfully designed studios provide an open layout with refined finishes that make the most of every square foot. Located in the desirable Plaza Area, residents enjoy proximity to Kansas City's top shopping and dining destinations. \n\nEach studio apartment at Cambria is crafted with convenience in mind, featuring in-home laundry and access to amenities like recycling services and guest apartment options. Whether indulging in the city’s vibrant lifestyle or relaxing in your own beautifully appointed home, Cambria offers a seamless blend of elegance and practicality in one of Kansas City's most sought-after neighborhoods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Kansas City, MO | Cambria",
      "seo_description": "Find modern studio apartments in Kansas City, MO at Cambria Luxury Apartment Homes. Enjoy refined finishes and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-plaza-area-kc",
      "search_query": "1 bedroom apartments plaza area",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Plaza Area, KC",
      "h2_subtitle": "Discover exceptional 1 bedroom apartments in the Plaza Area. Cambria offers modern comfort and convenience in Kansas City's vibrant neighborhood.",
      "page_copy": "Experience unparalleled living in the heart of Kansas City's Plaza Area with our 1 bedroom apartments at Cambria Luxury Apartment Homes. These thoughtfully designed residences offer spacious layouts with polished finishes, ensuring both comfort and style. Reside just steps away from premier shopping and dining options, bringing the best of Kansas City to your doorstep.\n\nAt Cambria, enjoy in-home conveniences like laundry facilities and select units with beautiful double balconies for outdoor relaxation. Community amenities such as guest apartment availability and recycling services further enhance your living experience. Choose a 1 bedroom apartment at Cambria to enjoy luxury and lifestyle in Kansas City's thriving Plaza Area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Plaza Area, KC",
      "seo_description": "Explore 1 bedroom apartments at Cambria in the Plaza Area, Kansas City. Modern living with city convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-jackson-county-cambria",
      "search_query": "2 bedroom apartments jackson county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Jackson County",
      "h2_subtitle": "Explore superior 2 bedroom apartments in Jackson County at Cambria Luxury Apartment Homes. Enjoy comfort and convenience in Kansas City.",
      "page_copy": "Cambria Luxury Apartment Homes offers top-tier 2 bedroom apartments in the vibrant heart of Jackson County. These spacious residences provide an ideal blend of comfort and luxury, featuring polished finishes and modern conveniences like in-home laundry. Situated in the thriving Plaza Area of Kansas City, residents are mere moments from the city’s best dining and shopping spots.\n\nOur community provides a host of amenities, including select units with stunning double balconies, perfect for enjoying city views. The availability of a guest apartment and recycling services add to the convenience and quality of life at Cambria. Choose our 2 bedroom apartments to enjoy an elevated living experience in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Jackson County, MO",
      "seo_description": "Find luxurious 2 bedroom apartments in Jackson County, MO at Cambria. Experience modern living with city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartments-near-rockhurst-university-kc-cambria",
      "search_query": "apartments near Rockhurst University Kansas City",
      "category": "School",
      "h1_title": "Apartments Near Rockhurst University, KC",
      "h2_subtitle": "Discover top-tier apartments near Rockhurst University in Kansas City. Cambria offers ideal living with modern amenities.",
      "page_copy": "Situated conveniently near Rockhurst University, Cambria Luxury Apartment Homes is the perfect choice for students and staff seeking quality apartments in Kansas City. Enjoy the ease of access to campus alongside a warm, welcoming home environment. Our location in the Plaza Area ensures that you're never far from the city's vibrant culture and entertainment options.\n\nAt Cambria, choose from studio, one-, and two-bedroom floor plans complete with in-home laundry and high-end finishes. Select units offer double balconies, perfect for leisure and relaxation. Community amenities such as guest apartments and recycling enhance your living experience, making Cambria the ideal residence near Rockhurst University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rockhurst University, KC",
      "seo_description": "Find ideal apartments near Rockhurst University, Kansas City at Cambria. Modern homes with a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "luxury-apartments-near-umkc-kansas-city",
      "search_query": "luxury apartments close to University of Missouri-Kansas City",
      "category": "School",
      "h1_title": "Luxury Apartments Near UMKC, Kansas City",
      "h2_subtitle": "Experience upscale living close to the University of Missouri-Kansas City. Cambria offers luxury and convenience.",
      "page_copy": "Cambria Luxury Apartment Homes boasts an enviable location close to the University of Missouri-Kansas City, offering a sophisticated living environment ideal for students and faculty alike. Nestled in the esteemed Plaza Area, our luxury apartments provide easy access to UMKC along with the best of Kansas City's shopping and dining.\n\nChoose from elegant studio, one-, and two-bedroom apartments featuring upscale finishes and in-home laundry facilities. Select units come with double balconies, providing a perfect spot for relaxation. With community features like guest apartment availability and recycling, Cambria offers a harmonious blend of comfort and convenience near UMKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near UMKC, Kansas City",
      "seo_description": "Discover luxury apartments near UMKC in Kansas City at Cambria. Upscale living coupled with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartment-homes-near-kcai-plaza-area",
      "search_query": "apartment homes near Kansas City Art Institute Plaza Area",
      "category": "School",
      "h1_title": "Apartment Homes Near KCAI, Plaza Area",
      "h2_subtitle": "Find stylish apartment homes near Kansas City Art Institute in the lively Plaza Area. Cambria offers the perfect blend of artful living.",
      "page_copy": "Located in the dynamic Plaza Area, Cambria Luxury Apartment Homes provide an ideal living space near the Kansas City Art Institute. Our proximity to KCAI makes it the perfect choice for students and art enthusiasts seeking a vibrant cultural environment intertwined with modern living conveniences.\n\nExplore our variety of studio, one-, and two-bedroom floor plans, all featuring modern amenities such as in-home laundry and elegant finishes. Some units boast double balconies, offering enviable views of the city. With community benefits like guest apartment access and efficient recycling services, Cambria creates an exceptional living experience near the Kansas City Art Institute.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near KCAI, Plaza Area",
      "seo_description": "Discover apartment homes near Kansas City Art Institute in the Plaza Area at Cambria. Enjoy modern, artistic living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartments-close-to-longfellow-elementary-school-kc-mo",
      "search_query": "apartments close to Longfellow Elementary School KC MO",
      "category": "School",
      "h1_title": "Apartments Close to Longfellow Elementary KC MO",
      "h2_subtitle": "Explore apartments close to Longfellow Elementary School in KC MO. Cambria offers comfortable city living.",
      "page_copy": "Cambria Luxury Apartment Homes offers exceptional apartments close to Longfellow Elementary School in Kansas City.\n\nResidents can select from thoughtfully designed studio, one-, and two-bedroom layouts, all equipped with contemporary amenities like in-home laundry. Some units feature spacious double balconies, perfect for leisure and entertaining. Living at Cambria means easy access to both peaceful residential spaces and bustling city life, making it ideal for those connected to Longfellow Elementary School in KC, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Longfellow Elementary KC MO",
      "seo_description": "Find Cambria's stylish apartments near Longfellow Elementary School KC MO. Enjoy modern living in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "housing-near-kansas-city-university-64112",
      "search_query": "housing near Kansas City University 64112",
      "category": "School",
      "h1_title": "Housing Near Kansas City University 64112",
      "h2_subtitle": "Discover premium housing near Kansas City University in the 64112 area. Cambria offers the ultimate urban living experience.",
      "page_copy": "Cambria Luxury Apartment Homes is the perfect choice for those seeking housing near Kansas City University in the 64112 area. Situated in the sought-after Plaza Area, our community offers an ideal blend of comfort and convenience.\n\nWe provide a selection of studio, one-, and two-bedroom apartments, each featuring upscale finishes and essential amenities like in-home laundry. Some apartments offer double balconies, adding an extra layer of sophistication. Enjoy proximity to Kansas City's renowned shopping and dining, all while living just moments away from Kansas City University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Kansas City University 64112",
      "seo_description": "Explore Cambria's premium housing options near Kansas City University in the 64112 area. Modern living with unbeatable convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "luxury-apartments-near-childrens-mercy-adele-hall-campus",
      "search_query": "luxury apartments near children's mercy adele hall campus kansas city",
      "category": "Hospital",
      "h1_title": "Luxury Apartments Near Children's Mercy KC",
      "h2_subtitle": "Find luxury apartments near Children's Mercy Adele Hall Campus in Kansas City. Cambria provides sophisticated living in the Plaza Area.",
      "page_copy": "Cambria Luxury Apartment Homes offers premier living choices for those seeking luxury apartments near Children's Mercy Adele Hall Campus in Kansas City. Located in the vibrant Plaza Area, our apartments combine upscale features with a convenient location.\n\nChoose from our exquisite studio, one-, and two-bedroom floor plans that include in-home laundry and modern finishes. Enjoy the perks of select units with double balconies, providing stunning city views. Cambria's strategic location ensures you're minutes from Kansas City's top attractions, making it a prime choice for anyone seeking proximity to Children's Mercy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Children's Mercy KC",
      "seo_description": "Discover Cambria's luxury apartments near Children's Mercy in Kansas City's Plaza Area. Upscale living close to health campuses.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "plaza-area-apartments-close-to-truman-medical-center",
      "search_query": "plaza area apartments close to university health truman medical center",
      "category": "Hospital",
      "h1_title": "Plaza Area Apartments Near Truman Medical Center",
      "h2_subtitle": "Explore Plaza Area apartments close to University Health Truman Medical Center. Cambria offers stylish living with great convenience.",
      "page_copy": "Cambria Luxury Apartment Homes presents a refined living experience in the heart of Kansas City's Plaza Area. Perfectly positioned for those seeking apartments close to University Health Truman Medical Center, our community combines elegance with practicality.\n\nResidents can choose from spacious studio, one-, and two-bedroom layouts, all featuring high-end finishes and in-home laundry. Select units boast double balconies, providing a breathtaking view of the cityscape. Enjoy unmatched convenience with easy access to both medical and leisure destinations, making Cambria a prime choice for healthcare professionals and urban dwellers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Plaza Area Apartments Near Truman Medical Center",
      "seo_description": "Find Cambria's stylish Plaza Area apartments near University Health Truman Medical Center. Comfort and convenience close to Kansas City health hubs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartments-near-mill-creek-park-kansas-city",
      "search_query": "apartments near Mill Creek Park Kansas City",
      "category": "Park",
      "h1_title": "Apartments Near Mill Creek Park Kansas City",
      "h2_subtitle": "Discover exquisite apartments near Mill Creek Park in Kansas City. Cambria offers unmatched luxury and convenience.",
      "page_copy": "Nestled in the Plaza Area, Cambria Luxury Apartment Homes offers stunning apartments near Mill Creek Park Kansas City. Our location ensures you have easy access to the lush greenery of Mill Creek Park while enjoying upscale urban living.\n\nResidents can choose from a variety of elegant studio, one-, and two-bedroom apartments, each appointed with modern finishes and in-home laundry facilities. With amenities like double balconies in select units, you can enjoy scenic views right from your home. Experience the best of both worlds with serene natural spaces and a vibrant city lifestyle at Cambria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mill Creek Park Kansas City",
      "seo_description": "Explore Cambria's luxurious apartments near Mill Creek Park, Kansas City. Perfect blend of nature and city in the Plaza Area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167590",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Cambria offers elegant apartments near Kansas City International Airport, blending convenience with luxury in the Plaza Area.",
      "page_copy": "Cambria Luxury Apartment Homes positions you conveniently close to Kansas City International Airport while providing a luxurious residence you can call home. Located in the iconic Plaza Area, Cambria combines urban sophistication with easy access to travel hubs.\n\nOur community features beautifully designed studio, one-, and two-bedroom apartments that come with in-home laundry and sophisticated finishes. Some units offer double balconies for you to unwind and enjoy panoramic views. Make your living experience seamless and enjoyable with close proximity to travel, shopping, and dining, all at Cambria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
      "featured_image_media": {
        "alt_text": "View of Country Club Plaza, Kansas City, featuring Spanish-inspired architecture and shops.",
        "public_id": "019fc924-31ed-72a9-b60d-d022fe7016c5",
        "storage_key": "property/6767906449167590/019fc924-31ed-72a9-b60d-d022fe7016c5.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find Cambria's luxurious apartments near Kansas City International Airport. Experience convenience and elegance in the Plaza Area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701864482"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLC3S3TL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/5363dbf3-a19c-4d90-b73d-b4149a857aa5/app.js?nocache=1&gaTracking=G-WWXTYHJMTN&buttonbgcolor=612033&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-296-9856"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik9JYXRwd3N3WXp1RzVsTDNaMTVPSXc9PSIsInZhbHVlIjoiaTZzWmZ3NkJxZFdrd1JXR1FvcnFjQT09IiwibWFjIjoiNjBiNTUxNTJkN2ZmZmJkYzA2ZmYxNDdiNmRlZGIzNDYwNTMwZDU4YmEzZDUyZmMxOThjZGNkZGU1OTk0MDY2NSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701864482",
  "custom_google_gtm_id": "GTM-WLC3S3TL",
  "custom_rollout_phase": "Batch 2",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/5363dbf3-a19c-4d90-b73d-b4149a857aa5/app.js?nocache=1&gaTracking=G-WWXTYHJMTN&buttonbgcolor=612033&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-296-9856",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik9JYXRwd3N3WXp1RzVsTDNaMTVPSXc9PSIsInZhbHVlIjoiaTZzWmZ3NkJxZFdrd1JXR1FvcnFjQT09IiwibWFjIjoiNjBiNTUxNTJkN2ZmZmJkYzA2ZmYxNDdiNmRlZGIzNDYwNTMwZDU4YmEzZDUyZmMxOThjZGNkZGU1OTk0MDY2NSJ9",
  "custom_audioeye_site_id": "d67627b7-35ff-4d2d-96b7-548b2532e60f",
  "custom_audioeye_site_hash": "9e8948c62a0712a19f88d5d75a03063d"
};

export const generatedAt = '2026-11-03T23:00:58.033Z';
